import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import GameLogic from "@bd-core/game-logic";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import { createInfoTooltipLayer } from "@bd-utils/info-tooltip";

export class HomePage extends BD_Component {
    constructor() {
        super();

        this.id = "home-page";
        this.template = "home-page-template";

        this.elms = {
            app: ".app",
            homePage: ".home-page",
            timelineLikeButton: ".actions__likes__button",
            chatLikeButton: ".subject-actions__likes__button",
            footerLikeButton: ".footer__likes__button",
            footerLikeOption: ".like-option",
            likeWrap:
                ".actions__likes, .subject-actions__likes, .footer__likes",
            reactions: ".actions__reactions",
            voteOptionButton: ".vote-option__button",
            voteSection: ".timeline-vote",
            chatDrawer: ".home-page__chat",
            chatDrawerSubject: ".home-page__chat__subject",
            chatDrawerBackButton: ".home-page__chat__back",
            chatDrawerList: ".home-page__chat__list",
            chatDrawerSubjectChallenger: ".subject-status__challenger",
            chatDrawerSubjectAvatar: ".subject-status__challenger__avatar img",
            chatDrawerSubjectName: ".subject-status__challenger__name",
            chatDrawerSubjectAction: ".subject-status__challenger__action",
            chatDrawerSubjectOpponent: ".subject-status__opponent",
            chatDrawerOpponentAvatar: ".subject-status__opponent__avatar img",
            chatDrawerOpponentName: ".subject-status__opponent__name",
            chatDrawerOpponentAction: ".subject-status__opponent__action",
            chatDrawerPointsValue: ".subject-status__points__value",
            chatDrawerTopicImage: ".subject-topic__image",
            chatDrawerTopicTitle: ".subject-topic__title",
            chatDrawerTopicTagTitle: ".subject-topic__tag__title",
            chatDrawerTopicPrompt: ".subject-topic__prompt",
            chatDrawerTopicQuestion: ".subject-topic__question",
            chatDrawerTopicQuestionImage: ".subject-topic__question__image",
            chatDrawerTopicQuestionText: ".subject-topic__question__text",
            chatDrawerTopicRespond: ".subject-topic__respond",
            chatDrawerTopicRespondImage: ".subject-topic__respond__image",
            chatDrawerTopicRespondText: ".subject-topic__respond__text",
            chatDrawerTopicField: ".subject-topic__field",
            chatDrawerTopicFieldLeft: ".subject-topic__field--left",
            chatDrawerTopicFieldRight: ".subject-topic__field--right",
            chatDrawerLeftPlayer:
                ".subject-topic__field--left .subject-topic__field__player.player-left",
            chatDrawerLeftPlayerAvatar:
                ".subject-topic__field--left .subject-topic__field__player.player-left .subject-topic__field__player__avatar",
            chatDrawerLeftPlayerName:
                ".subject-topic__field--left .subject-topic__field__player.player-left .subject-topic__field__player__name",
            chatDrawerLeftScoreValue:
                ".subject-topic__field--left .subject-topic__field__score__value",
            chatDrawerLeftScoreTimerValue:
                ".subject-topic__field--left .subject-topic__field__score__timer__value",
            chatDrawerLeftTimeValue:
                ".subject-topic__field--left .subject-topic__field__time__value",
            chatDrawerRightPlayer:
                ".subject-topic__field--right .subject-topic__field__player.player-right",
            chatDrawerRightPlayerAvatar:
                ".subject-topic__field--right .subject-topic__field__player.player-right .subject-topic__field__player__avatar",
            chatDrawerRightPlayerName:
                ".subject-topic__field--right .subject-topic__field__player.player-right .subject-topic__field__player__name",
            chatDrawerRightPlayerText:
                ".subject-topic__field--right .subject-topic__field__player.player-right .subject-topic__field__player__text",
            chatDrawerRightScoreValue:
                ".subject-topic__field--right .subject-topic__field__score__value",
            chatDrawerRightScoreTimerValue:
                ".subject-topic__field--right .subject-topic__field__score__timer__value",
            chatDrawerRightTimeValue:
                ".subject-topic__field--right .subject-topic__field__time__value",
            chatDrawerResultAvatar: ".subject-actions__result__avatar",
            chatDrawerResultName: ".subject-actions__result__name",
            chatDrawerLikesCount: ".subject-actions__likes__count",
            chatCommentInput: ".home-page__chat__comment__input",
            chatCommentSubmit: ".home-page__chat__comment__submit",
            dailyContent: ".home-page__daily__content",
            timelineList: ".home-page__timeline__list",
            timelineItem: ".home-page__timeline__item",
            actionsReactionsCount: ".actions__reactions__count",
            storeButton: ".home-page__store",
            managerButton: ".home-page__header__button.manager",
            managerDropdown: ".home-page__header__dropdown",
            logoutPopupModal: ".home-page__modal.logout-popup",
            logoutPopupCancelButton:
                ".home-page__modal.logout-popup .modal__actions__cancel",
            logoutPopupConfirmButton:
                ".home-page__modal.logout-popup .modal__actions__confirm",
            abandonNotificationPopupModal:
                ".home-page__modal.abandon-notification-popup",
            abandonNotificationPopupCancelButton:
                ".home-page__modal.abandon-notification-popup .modal__actions__cancel",
            abandonNotificationPopupConfirmButton:
                ".home-page__modal.abandon-notification-popup .modal__actions__confirm",
            viewDashboard: ".view-dashboard",
            timelineTextarea: ".footer__comments__input__textarea",
            timelineInputSection: ".footer__comments__input",
            timelineCommentList: ".footer__comments__list",
            timelineCommentSubmit: ".footer__comments__input__submit",
            notificationsOverlay: ".home-page__notifications--overlay",
            notifOpenButton: ".home-page__header__button.notifications",
            notifCloseButton: ".home-page__notifications__close",
            notifMarkAll:
                ".home-page__notifications__mark-all, [data-role='notif-mark-all']",
            notifListUnread:
                "ul.new-notifications, [data-role='notif-list-unread']",
            notifListRead:
                "ul.old-notifications, [data-role='notif-list-read']",
            /** Inner card only (not the full-screen `home-page__notifications--overlay`). */
            notifPanel: ".home-page__notifications",
            challengedRespondButton: ".item-challenge__respond.is-player",
            challengeRespondBlock: ".item-challenge__respond",
            respondTextarea: ".item-challenge__respond__textarea",
            respondSubmitButton: ".item-challenge__respond__submit",
            challengedRightRespondButton:
                ".item-challenge__field__player.player-right.is-player",
            challengedRightRespondBlock:
                ".item-challenge__field__player.player-right",
            subjectChallengedRightRespondButton:
                ".subject-topic__field__player.player-right.is-player",
            activityFullPopup: ".home-page__modal.activity-full-popup",
            activityFullModal: ".home-page__modal.activity-full-popup",
            fullscreenBack:
                ".home-page__modal.activity-full-popup .modal__header__back",
            fullscreenInfoTagLabel:
                ".home-page__modal.activity-full-popup .modal__header__tag > span",
            fullscreenImage:
                ".home-page__modal.activity-full-popup .modal__header__image img",
            fullscreenTitle:
                ".home-page__modal.activity-full-popup .modal__header__title",
            fullscreenContinueButton:
                ".home-page__modal.activity-full-popup .js-handle-activity-steps",
            modalSections:
                ".home-page__modal.activity-full-popup .modal__sections",
            modalStep: ".home-page__modal.activity-full-popup .modal__step",
            modalSectionActiveBody:
                ".modal__section.section-active .modal__section__body",
            modalSectionSegment: ".modal__section__segment",
            segmentTextInputTemplate: ".segment-text-input.is-template",
            segmentMultipleChoiceTemplate:
                ".segment-multiple-choice.is-template",
            isTemplateSelector: ".is-template",
            segmentMultipleChoice: ".segment-multiple-choice",
            segmentTitle: ".segment__title",
            segmentTextareaField: ".segment__textarea",
            segmentOptions: ".segment__options",
            segmentTextarea:
                ".home-page__modal.activity-full-popup .modal__section__body .segment-text-input:not(.is-template) .segment__textarea",
            quizSegments:
                ".home-page__modal.activity-full-popup .quiz-segments",
            quizSegmentOption:
                ".home-page__modal.activity-full-popup .segment__option",
            segmentOption: ".segment__option",
            segmentOptionSelected: ".segment__option.is-selected",
            playerGridItem:
                ".home-page__modal.activity-full-popup .player-grid__item",
            playerGridItemSelected:
                ".home-page__modal.activity-full-popup .player-grid__item.is-selected",
            modalStepUnstarted:
                ".home-page__modal.activity-full-popup .modal__step.is-unstarted",
            modalProgressFill:
                ".home-page__modal.activity-full-popup .modal__header__timer__progress__fill",
            modalProgressFillSpan:
                ".home-page__modal.activity-full-popup .modal__header__timer__progress__fill span",
            modalProgressTrack:
                ".home-page__modal.activity-full-popup .modal__header__timer__progress",
            playerIdDataKey: "player-id",
            activityFullSectionFinished:
                ".home-page__modal.activity-full-popup .section-finished",
            quizResultsPointsValue: ".results--quiz .points-value",
            quizResultsTimeValue: ".results--quiz .time-value",
            quizResultsAnswersCorrectText: ".answers-correct .answers-text",
            quizResultsAnswersIncorrectText: ".answers-incorrect .answers-text",
            finishedSectionSubtitle: ".modal__section__subtitle",
            finishedSectionTitle: ".modal__section__title",
            raceTimerTime:
                ".home-page__modal.activity-full-popup .race-timer__time",
            raceResultsTime:
                ".home-page__modal.activity-full-popup .results--race__time",
            quizSummaryMetaKey: "__quizSummary",
            raceSummaryMetaKey: "__raceSummary",
            attrQuestionIndex: "data-question-index",
        };
        this.classes = {
            modalOpen: "modal--is-open",
            isOpen: "is-open",
            isMenuOpen: "is-menu-open",
            holdReleasedEarly: "is-hold-released-early",
            hasVoted: "has-voted",
            hasLiked: "has-liked",
            isDefault: "is-default",
            isCheers: "is-cheers",
            isSuccess: "is-success",
            isLekkerBezig: "is-lekker-bezig",
            isVerfrissend: "is-verfrissend",
            isLekkerLeren: "is-lekker-leren",
            isAmazing: "is-amazing",
            subjectTypeChallenge: "is-challenge",
            subjectTypeRace: "is-race",
            subjectTypeQuiz: "is-quiz",
            subjectTypeStatement: "is-statement",
            subjectTypeQuestion: "is-question",
            subjectHasWinner: "has-winner",
            chatItem: "home-page__chat__item",
            chatItemEmpty: "home-page__chat__item--empty",
            chatMessage: "chat-message",
            chatUser: "chat-user",
            chatUserAvatar: "chat-user__avatar",
            chatUserName: "chat-user__name",
            isActive: "is-active",
            notifOverlayOpen: "is-open",
            isPlayer: "is-player",
            hasOpened: "has-opened",
            hasAnswered: "has-answered",
            extraTypeRace: "is-race",
            extraTypeQuiz: "is-quiz",
            extraTypeQuestions: "is-questions",
            extraTypeAll: "is-race is-quiz is-questions",
            isSectionActive: "is-section-active",
            isSectionFinished: "is-section-finished",
            isSectionChallenge: "is-section-challenge",
            sectionAll:
                "is-section-active is-section-finished is-section-challenge",
            isSelected: "is-selected",
            isUnavailable: "is-unavailable",
            playerAll: "is-selected is-unavailable",
            isUnstarted: "is-unstarted",
            stepAll: "is-active is-unstarted",
            isTemplate: "is-template",
            quizTimerLabelOutside: "is-quiz-timer-label-outside",
            isAnswering: "is-answering",
            isCorrect: "is-correct",
            isIncorrect: "is-incorrect",
            isAnswered: "is-answered",
            sectionActive: "section-active",
            segmentOption: "segment__option",
            segmentOptionContent: "segment__option__content",
            segmentOptionBullet: "segment__option__bullet",
            segmentOptionText: "segment__option__text",
            sectionFinishedPanel: "section-finished",
            resultsQuiz: "results--quiz",
            pointsValue: "points-value",
            timeValue: "time-value",
            answersCorrect: "answers-correct",
            answersIncorrect: "answers-incorrect",
            answersText: "answers-text",
            modalSectionSubtitle: "modal__section__subtitle",
            modalSectionTitle: "modal__section__title",
            activityChallengedResponder:
                "activity-full-popup--challenged-responder",
        };
        this.likeVariants = [
            "cheers",
            "success",
            "lekker-bezig",
            "verfrissend",
            "lekker-leren",
            "amazing",
        ];
        this._activeLikeHold = null;
        this._events = this.getEvents();
        this._teamId = null;
        this._unfinishedAbandonedChallenge = null;
        this._infoTooltip = null;
        /** @type {Record<string, unknown> | null} */
        this._challengedActivityExtra = null;
        this._challengedActivityTimelineId = 0;
        /** @type {ReturnType<typeof setInterval> | null} */
        this._quizTimerIntervalId = null;
        this._quizTimerTotalSec = 0;
        this._quizTimerRemainingSec = 0;
        /** @type {ReturnType<typeof setInterval> | null} */
        this._raceTimerIntervalId = null;
        this._raceElapsedSec = 0;
        this._raceIndex = 0;
        this._quizIndex = 0;
        /** @type {unknown} */
        this._questions = {};
        this._userAnswers = {};
        /** @type {BD_JQuery | null} */
        this._quizMcTemplate = null;
        /** @type {BD_JQuery | null} */
        this._raceTextTemplate = null;
        /** @type {BD_JQuery | null} */
        this._raceMcTemplate = null;
    }

    getEvents() {
        const elms = this.elms;

        return [
            {
                selector: `${elms.timelineLikeButton}, ${elms.chatLikeButton}, ${elms.footerLikeButton}`,
                event: "mousedown touchstart",
                handler: this.handleLikeButtonHoldStart,
            },
            {
                selector: `${elms.timelineLikeButton}, ${elms.chatLikeButton}, ${elms.footerLikeButton}`,
                event: "click",
                handler: this.handleLikeButtonClick,
            },
            {
                selector: elms.footerLikeOption,
                event: "click",
                handler: this.handleFooterLikeOption,
            },
            {
                selector: elms.timelineItem,
                event: "click",
                handler: this.handleTimelineItemClick,
            },
            {
                selector: elms.chatDrawerBackButton,
                event: "click",
                handler: this.onCloseChat,
            },
            {
                selector: elms.voteOptionButton,
                event: "click",
                handler: this.handleVote,
            },
            {
                selector: elms.dailyContent,
                event: "click",
                handler: this.handleDailyContent,
            },
            {
                selector: elms.chatCommentSubmit,
                event: "click",
                handler: this.handleCommentSubmit,
            },
            {
                selector: elms.chatCommentInput,
                event: "keydown",
                handler: this.handleCommentKeydown,
            },
            {
                selector: elms.chatCommentInput,
                event: "input",
                handler: this.updateChatSubmitState,
            },
            {
                selector: elms.storeButton,
                event: "click",
                handler: this.handleStoreClick,
            },
            {
                selector: elms.managerButton,
                event: "click",
                handler: this.handleManagerButtonClick,
            },
            {
                selector: ".home-page__header__dropdown__item",
                event: "click",
                handler: this.handleManagerDropdownItemClick,
            },
            {
                selector: elms.logoutPopupCancelButton,
                event: "click",
                handler: this.handleLogoutPopupCancelClick,
            },
            {
                selector: elms.logoutPopupConfirmButton,
                event: "click",
                handler: this.handleLogoutPopupConfirmClick,
            },
            {
                selector: elms.abandonNotificationPopupCancelButton,
                event: "click",
                handler: this.handleAbandonNotificationPopupCancelClick,
            },
            {
                selector: elms.abandonNotificationPopupConfirmButton,
                event: "click",
                handler: this.handleAbandonNotificationPopupConfirmClick,
            },
            {
                selector: elms.viewDashboard,
                event: "click",
                handler: this.handleViewDashboardClick,
            },
            {
                selector: elms.notifOpenButton,
                event: "click",
                handler: this.handleNotificationsOpenClick,
            },
            {
                selector: elms.notifCloseButton,
                event: "click",
                handler: this.handleNotificationsCloseClick,
            },
            {
                selector: elms.notifMarkAll,
                event: "click",
                handler: this.handleNotificationsMarkAllClick,
            },
            {
                selector: ".home-page__notifications__item",
                event: "click",
                handler: this.handleNotificationItemOpen,
            },
            {
                selector: elms.timelineTextarea,
                event: "click",
                handler: this.handleTimelineTextareaClick,
            },
            {
                selector: elms.timelineTextarea,
                event: "keydown",
                handler: this.handleTimelineCommentKeydown,
            },
            {
                selector: elms.challengedRespondButton,
                event: "click",
                handler: this.handleChallengedRespondButtonClick,
            },
            {
                selector: elms.respondSubmitButton,
                event: "click",
                handler: this.handleRespondSubmitButtonClick,
            },
            {
                selector: `${elms.challengedRightRespondButton}, ${elms.subjectChallengedRightRespondButton}`,
                event: "click",
                handler: this.handleChallengedRightRespondButtonClick,
            },
            {
                selector: elms.fullscreenBack,
                event: "click",
                handler: this.closeChallengedActivityFullModal,
            },
            {
                selector: elms.fullscreenContinueButton,
                event: "click",
                handler: this.handleChallengedActivityStepsContinue,
            },
            {
                selector: elms.segmentTextarea,
                event: "input",
                handler: this.handleChallengedSegmentTextareaInput,
            },
            {
                selector: elms.quizSegmentOption,
                event: "click",
                handler: this.handleChallengedQuizSegmentOptionClick,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    async render() {
        this._teardownInfoTooltip();
        const data = this._data;
        this._teamId = localStorage.getItem("teamId");
        const homepageData = await this.fetchHomepageData();
        data.profile = homepageData.profile;
        data.active_challenge = homepageData.active_challenge;
        data.active_weekly_challenge = homepageData.active_weekly_challenge;
        data.timeline = homepageData.timeline;
        data.weekly_challenge_setup = homepageData.weekly_challenge_setup;
        this._unfinishedAbandonedChallenge =
            homepageData.unfinished_abandoned_challenge ?? null;

        const nCount =
            Number(homepageData.notifications_unread_count ?? 0) || 0;
        data.notifications_unread_count = nCount;
        data.has_unread_notifications = nCount > 0;
        data.notifications_unread_count_badge =
            nCount > 99 ? "99+" : String(nCount);

        data.store_page = this.getStorePageConfig();
        data.team_members = [];

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(this.elms.app).html(html);

        this._infoTooltip = createInfoTooltipLayer("home", $(this.elms.app));
        this._infoTooltip.setTriggerText(
            $(this.elms.app).find(".home-page__header__button.information"),
            CONFIG.game?.tooltip?.home_page ?? "",
        );

        this.populateTimeline();

        this.checkUnfinishedAbandonedChallenge();
        await this.consumePendingStoreTimelineOpen();
    }

    setGameState() {}

    _teardownInfoTooltip() {
        this._infoTooltip?.destroy();
        this._infoTooltip = null;
    }

    beforeDestroy() {
        this.clearChallengedActivityTimers();
        this.detachChatDrawerOutsideClose();
        this.closeNotificationsOverlay();
        this._teardownInfoTooltip();
    }

    /**
     * Store page ACF strings (same source as store-page template).
     * @returns {Record<string, unknown>}
     */
    getStorePageConfig() {
        const pages = CONFIG.game?.pages ?? [];
        const row = pages.find((p) => p.id === "store-page");
        return /** @type {Record<string, unknown>} */ (
            row?.data?.store_page ?? {}
        );
    }

    async consumePendingStoreTimelineOpen() {
        const pendingTimelineKey = "pendingHomeTimelineId";
        const pendingTimelineRaw = localStorage.getItem(pendingTimelineKey);
        if (!pendingTimelineRaw) {
            return;
        }

        // Clear first so stale values do not re-open timeline on later visits.
        localStorage.removeItem(pendingTimelineKey);
        const pendingTimelineId = Number(pendingTimelineRaw) || 0;
        if (!pendingTimelineId) {
            return;
        }

        await this.openTimelineById(pendingTimelineId);
    }

    // ===== HANDLERS =====
    handleLikeButtonClick(e) {
        e.preventDefault();
    }

    handleLikeButtonHoldStart(e) {
        if (e.type === "mousedown" && e.which !== 1) return;

        e.preventDefault();
        const $button = $(e.currentTarget);
        const $wrap = this.getLikeWrap($button);
        if (!$wrap.length) return;
        this.cancelLikeHold(false);

        const holdState = {
            $button,
            $wrap,
            holdCompleted: false,
        };
        this._activeLikeHold = holdState;
        $button.css("opacity", "0.5");

        holdState.timeout = setTimeout(() => {
            holdState.holdCompleted = true;
            $button.css("opacity", "1");
            $wrap.addClass(this.classes.isMenuOpen);
            this.bindLikeMenuOutsideClose($wrap);
        }, 250);

        holdState.onRelease = async () => {
            const wasHoldStateActive = this._activeLikeHold === holdState;
            this.cancelLikeHold(holdState.holdCompleted);
            if (!wasHoldStateActive || holdState.holdCompleted) return;

            await this.toggleLikeForWrap($wrap);
        };

        $(document).on(
            "mouseup.likeHold touchend.likeHold touchcancel.likeHold",
            holdState.onRelease,
        );
    }

    cancelLikeHold(keepMenuOpen = false) {
        const holdState = this._activeLikeHold;
        if (!holdState) return;

        clearTimeout(holdState.timeout);
        holdState.$button.css("opacity", "1");
        $(document).off(
            "mouseup.likeHold touchend.likeHold touchcancel.likeHold",
        );
        if (!keepMenuOpen) {
            holdState.$wrap.removeClass(this.classes.isMenuOpen);
        }
        this._activeLikeHold = null;
    }

    bindLikeMenuOutsideClose($wrap) {
        $(document)
            .off("click.likeMenuClose")
            .on("click.likeMenuClose", (event) => {
                if (!$wrap.get(0)?.contains(event.target)) {
                    $wrap.removeClass(this.classes.isMenuOpen);
                    $(document).off("click.likeMenuClose");
                }
            });
    }

    async handleFooterLikeOption(e) {
        e.preventDefault();
        e.stopPropagation();

        const $option = $(e.currentTarget);
        const $wrap = this.getLikeWrap($option);
        const timelineId = this.getTimelineIdFromWrap($wrap);
        if (!timelineId) return;

        const variant = this.getVariantFromOption($option);
        if (!variant) return;

        $wrap.removeClass(this.classes.isMenuOpen);
        $(document).off("click.likeMenuClose");
        this.cancelLikeHold(true);

        await this.likeTimelineWithVariant(timelineId, variant);
    }

    /**
     * Open timeline detail when clicking anywhere on a timeline item.
     * Ignores clicks on like button and vote buttons so those keep their own behavior.
     */
    async handleTimelineItemClick(e) {
        const $item = $(e.currentTarget);
        const $inlineSubmitButton = $(e.target).closest(
            this.elms.timelineCommentSubmit,
        );
        if ($inlineSubmitButton.length) {
            e.preventDefault();
            const $input = $inlineSubmitButton
                .closest(this.elms.timelineInputSection)
                .find(this.elms.timelineTextarea)
                .first();
            await this.submitInlineTimelineComment($input);
            return;
        }

        if ($item.hasClass("is-stats")) return;

        if (
            $(e.target).closest("button").length ||
            $(e.target).closest(".actions__likes").length ||
            $(e.target).closest(".vote-option").length ||
            $(e.target).closest(".footer__likes__button").length ||
            $(e.target).closest(".footer__comments").length ||
            $(e.target).closest(".footer__comments__input").length ||
            $(e.target).closest(".footer__comments__input__textarea").length ||
            $(e.target).closest(".footer__comments__input__submit").length ||
            $(e.target).closest(this.elms.challengeRespondBlock).length ||
            $(e.target).closest(this.elms.challengedRightRespondBlock).length
        ) {
            return;
        }
        e.preventDefault();
        const timelineId =
            $item.find(this.elms.reactions).data("timeline-id") ||
            $item.find(".actions__likes").data("timeline-id") ||
            $item.data("timeline-id");
        if (!timelineId) return;
        const teamId = localStorage.getItem("teamId");
        const [res] = await bdjs.goAsync(
            bdapi.post("game/get-timeline-data", {
                team_id: teamId,
                timeline_id: timelineId,
            }),
        );
        const item = res?.data?.data?.[0] ?? null;
        if (item) {
            this.populateChatDrawer(item);
        }
        this.pauseAllVideos();
        $(this.elms.chatDrawer).addClass(this.classes.isOpen);
        this.updateChatSubmitState();
        this.attachChatDrawerOutsideClose();
    }

    /**
     * Populate the chat drawer with timeline data (challenge or extras).
     * Branches on `item.type` to render either the challenge subject or the
     * race/quiz/question extras subject; common reset, likes and comments
     * are applied for both.
     * @param {Object} item Timeline item from get-timeline-data API.
     */
    populateChatDrawer(item) {
        const themeURL = CONFIG.themeURL || "";
        const elms = this.elms;
        const $drawer = $(elms.chatDrawer);
        $drawer.data("timeline-id", item.id);

        this.resetChatDrawerSubject($drawer);

        const itemType = (item?.type || "challenge").toLowerCase();
        if (itemType === "extras") {
            this.populateChatDrawerExtras(item, $drawer, themeURL);
        } else {
            this.populateChatDrawerChallenge(item, $drawer, themeURL);
        }

        this.populateChatDrawerLikes(item, $drawer);
        this.populateChatDrawerComments(item, $drawer, themeURL);
    }

    /**
     * Strip every modifier class and per-element state that is owned by
     * `populateChatDrawer*` so the next render starts from a clean slate.
     */
    resetChatDrawerSubject($drawer) {
        const elms = this.elms;
        const cls = this.classes;
        const $subject = $drawer.find(elms.chatDrawerSubject);

        $subject
            .removeClass(
                `${cls.subjectTypeRace} ${cls.subjectTypeQuiz} ${cls.subjectTypeQuestion} ${cls.subjectTypeStatement}`,
            )
            .removeClass(cls.subjectHasWinner)
            .removeClass("is-text-content is-media-content");

        $subject
            .find(elms.chatDrawerSubjectChallenger)
            .removeClass("is-winner");
        $subject.find(elms.chatDrawerSubjectOpponent).removeClass("is-winner");
        $subject.find(elms.chatDrawerTopicFieldLeft).removeClass("is-winner");
        $subject.find(elms.chatDrawerTopicFieldRight).removeClass("no-result");
        $subject.find(elms.chatDrawerTopicFieldRight).removeClass("is-winner");
        $subject
            .find(elms.chatDrawerRightPlayer)
            .removeClass(`${cls.isPlayer} ${cls.hasOpened} ${cls.hasAnswered}`);
        $subject
            .find(elms.chatDrawerTopicRespond)
            .removeClass(`${cls.isPlayer} ${cls.hasAnswered}`);
        $drawer.find(elms.chatDrawerTopicPrompt).text("");
        $drawer.find(elms.chatDrawerTopicQuestionText).text("");
        $drawer.find(elms.chatDrawerTopicRespondText).empty();
    }

    /**
     * Populate the chat drawer for a `challenge` timeline item (existing
     * behavior — preserves the `is-text-content` / `is-media-content` flow
     * that drives the daily-challenge submission preview).
     */
    populateChatDrawerChallenge(item, $drawer, themeURL) {
        const elms = this.elms;
        const ud = item.user_data || {};
        const cd = item.challenge_data || {};
        const avatar = ud.avatar || `${themeURL}/assets/images/player.png`;
        const displayName = ud.display_name || "";
        const challengeTitle = cd.title || "";
        const challengeImage =
            (cd.image && typeof cd.image === "object" && cd.image.url) ||
            cd.image ||
            `${themeURL}/assets/images/daily-banner.png`;
        const points = cd.points != null ? cd.points : 0;
        const pointsLabel = points > 0 ? `+${points}` : String(points);

        const $subject = $drawer.find(elms.chatDrawerSubject);

        $subject
            .find(elms.chatDrawerSubjectAction)
            .text(item.status_label || "");
        $drawer
            .find(elms.chatDrawerSubjectAvatar)
            .attr("src", avatar)
            .attr("alt", displayName);
        $drawer.find(elms.chatDrawerSubjectName).text(displayName);
        $drawer.find(elms.chatDrawerPointsValue).text(pointsLabel);
        $drawer
            .find(elms.chatDrawerTopicImage)
            .attr("src", challengeImage)
            .attr("alt", challengeTitle);
        $drawer.find(elms.chatDrawerTopicTitle).text(challengeTitle);
        $drawer.find(elms.chatDrawerTopicTagTitle).text(challengeTitle);

        const submission = item.submission || {};
        const submissionType = submission.completion_type || "";
        const hasSubmission =
            submission.completion_content != null &&
            submission.completion_content !== "";
        const $subjectTopicContent = $drawer.find(".subject-topic__content");

        if (submissionType) {
            $subject.addClass(
                submissionType === "text"
                    ? "is-text-content"
                    : "is-media-content",
            );
        }

        if (hasSubmission) {
            const content = submission.completion_content;
            if (submissionType === "text") {
                $subjectTopicContent.text(content);
            } else if (
                submissionType === "photo" ||
                submissionType === "image"
            ) {
                $subjectTopicContent.html(
                    `<img src="${this.escapeHtml(content)}" alt="Challenge submission" />`,
                );
            } else if (submissionType === "video") {
                $subjectTopicContent.html(
                    `<video src="${this.escapeHtml(content)}" controls playsinline></video>`,
                );
            } else {
                $subjectTopicContent.empty();
            }
        } else {
            $subjectTopicContent.empty();
        }

        $drawer
            .find(elms.chatDrawerResultAvatar)
            .attr("src", avatar)
            .attr("alt", displayName);
        $drawer.find(elms.chatDrawerResultName).text(displayName);
    }

    /**
     * Populate the chat drawer for an `extras` timeline item (race, quiz,
     * question). Mirrors `renderTimelineExtrasItem` so the drawer surface
     * matches the timeline row.
     */
    populateChatDrawerExtras(item, $drawer, themeURL) {
        const elms = this.elms;
        const cls = this.classes;
        const $subject = $drawer.find(elms.chatDrawerSubject);

        const ed = item.extra_data || {};
        const ud = item.user_data || {};
        const cu = item.challenged_user || {};
        const extrasType = (ed.type || "").toString().toLowerCase();

        const challengerAvatar =
            ud.avatar || `${themeURL}/assets/images/player.png`;
        const challengerName = ud.display_name || "";
        const opponentAvatar =
            cu.avatar || `${themeURL}/assets/images/player.png`;
        const opponentName = cu.display_name || "";
        const title = ed.title || "";

        $subject.addClass(this.getExtrasChatSubjectClass(extrasType));

        const challengerId = ud.ID != null ? Number(ud.ID) : null;
        const opponentId = cu.ID != null ? Number(cu.ID) : null;
        const winnerId =
            item.winner_user_id != null && item.winner_user_id !== "0"
                ? Number(item.winner_user_id)
                : null;
        if (winnerId != null && winnerId > 0) {
            $subject.addClass(cls.subjectHasWinner);
            if (challengerId != null && winnerId === challengerId) {
                $subject
                    .find(elms.chatDrawerSubjectChallenger)
                    .addClass("is-winner");
            }
            if (opponentId != null && winnerId === opponentId) {
                $subject
                    .find(elms.chatDrawerSubjectOpponent)
                    .addClass("is-winner");
            }
        }

        $drawer
            .find(elms.chatDrawerSubjectAvatar)
            .attr("src", challengerAvatar)
            .attr("alt", challengerName);
        $drawer.find(elms.chatDrawerSubjectName).text(challengerName);
        $subject.find(elms.chatDrawerSubjectAction).text("challenged");

        $drawer
            .find(elms.chatDrawerOpponentAvatar)
            .attr("src", opponentAvatar)
            .attr("alt", opponentName);
        $drawer.find(elms.chatDrawerOpponentName).text(opponentName);
        $subject
            .find(elms.chatDrawerOpponentAction)
            .text(extrasType ? `to a ${extrasType}` : "");

        const pointsValue =
            item.points_earned != null ? Number(item.points_earned) : 0;
        const pointsLabel = pointsValue > 0 ? `+${pointsValue}` : "+50";
        $drawer.find(elms.chatDrawerPointsValue).text(pointsLabel);

        $drawer.find(elms.chatDrawerTopicTitle).text(title);
        $drawer
            .find(elms.chatDrawerTopicTagTitle)
            .text(this.getExtrasTypeDisplay(extrasType).label);
        $drawer.find(".subject-topic__content").empty();

        if (extrasType === "race" || extrasType === "quiz") {
            this.populateChatDrawerExtrasField(item, $drawer, themeURL);
        } else if (extrasType === "question") {
            this.populateChatDrawerExtrasQuestion(item, $drawer, themeURL);
        }

        $drawer
            .find(elms.chatDrawerResultAvatar)
            .attr("src", challengerAvatar)
            .attr("alt", challengerName);
        $drawer.find(elms.chatDrawerResultName).text(challengerName);
    }

    /**
     * Fill `.subject-topic__question` / `.subject-topic__respond` with both
     * players' answers for extras type `question`, matching
     * `renderTimelineExtrasItem` (challenger answer + opponent answer or pending).
     */
    populateChatDrawerExtrasQuestion(item, $drawer, themeURL) {
        const elms = this.elms;
        const cls = this.classes;
        const ed = item.extra_data || {};
        const ud = item.user_data || {};
        const cu = item.challenged_user || {};
        const submission = item.submission || null;
        const response = item.response || null;

        const challengerAvatar =
            ud.avatar || `${themeURL}/assets/images/player.png`;
        const challengerName = ud.display_name || "";
        const opponentAvatar =
            cu.avatar || `${themeURL}/assets/images/player.png`;
        const opponentName = cu.display_name || "";

        const opponentId = cu?.ID != null ? Number(cu.ID) : null;
        const currentUserId =
            this._data?.profile?.ID != null
                ? Number(this._data.profile.ID)
                : null;
        const isCurrentUserChallenged =
            opponentId != null &&
            currentUserId != null &&
            opponentId === currentUserId;

        const responseClass =
            response != null
                ? cls.hasAnswered
                : isCurrentUserChallenged
                  ? cls.isPlayer
                  : "";
        const responseContent =
            response != null
                ? this.escapeHtml(String(response?.answer ?? ""))
                : isCurrentUserChallenged
                  ? `${this._data.home_page.timeline.extra_respond_button_label}`
                  : `<b>${this.escapeHtml(opponentName)}</b> ${this._data.home_page.timeline.extra_pending_response_button_label}`;

        $drawer
            .find(elms.chatDrawerTopicPrompt)
            .text(String(ed.question ?? ""));

        $drawer
            .find(elms.chatDrawerTopicQuestionImage)
            .attr("src", challengerAvatar)
            .attr("alt", challengerName);
        $drawer
            .find(elms.chatDrawerTopicQuestionText)
            .text(String(submission?.answer ?? ""));

        $drawer
            .find(elms.chatDrawerTopicRespondImage)
            .attr("src", opponentAvatar)
            .attr("alt", opponentName);
        $drawer.find(elms.chatDrawerTopicRespond).addClass(responseClass);
        $drawer.find(elms.chatDrawerTopicRespondText).html(responseContent);
    }

    /**
     * Fill the left/right player slots inside `.subject-topic__field` with
     * the same data shape the timeline uses (`__quizSummary` / `__raceSummary`).
     * Applies `no-result` and `is-player` modifiers so pending-response and
     * "your turn" states render the same way as the timeline row.
     */
    populateChatDrawerExtrasField(item, $drawer, themeURL) {
        const elms = this.elms;
        const cls = this.classes;
        const ed = item.extra_data || {};
        const ud = item.user_data || {};
        const cu = item.challenged_user || {};
        const extrasType = (ed.type || "").toString().toLowerCase();
        const submission = item.submission || null;
        const response = item.response || null;

        const challengerAvatar =
            ud.avatar || `${themeURL}/assets/images/player.png`;
        const challengerName = ud.display_name || "";
        const opponentAvatar =
            cu.avatar || `${themeURL}/assets/images/player.png`;
        const opponentName = cu.display_name || "";

        const userSummary =
            extrasType === "quiz"
                ? submission?.answer?.__quizSummary
                : extrasType === "race"
                  ? submission?.answer?.__raceSummary
                  : null;
        const responseSummary =
            extrasType === "quiz"
                ? response?.answer?.__quizSummary
                : extrasType === "race"
                  ? response?.answer?.__raceSummary
                  : null;

        const formatTime = (sec) => {
            if (extrasType === "quiz") {
                return this.formatQuizCompletionTimeSec(sec);
            }
            if (extrasType === "race") {
                return this.formatRaceCompletionTimeSec(sec);
            }
            return sec != null && sec !== "" ? String(sec) : "";
        };
        const userTime = formatTime(userSummary?.completionTimeSec);
        const responseTime = formatTime(responseSummary?.completionTimeSec);
        const userScore =
            userSummary?.totalPoints != null ? userSummary.totalPoints : "";
        const responseScore =
            responseSummary?.totalPoints != null
                ? responseSummary.totalPoints
                : "";

        const { leftClass, rightClass } =
            this.getExtrasWinnerFieldClasses(item);
        const leftPlayerName =
            leftClass === "is-winner"
                ? this.formatExtrasWinnerNameText(
                      challengerName,
                      extrasType,
                      themeURL,
                  )
                : challengerName;

        $drawer
            .find(elms.chatDrawerLeftPlayerAvatar)
            .attr("src", challengerAvatar)
            .attr("alt", challengerName);
        if (leftClass === "is-winner") {
            $drawer.find(elms.chatDrawerLeftPlayerName).html(leftPlayerName);
        } else {
            $drawer.find(elms.chatDrawerLeftPlayerName).text(leftPlayerName);
        }
        $drawer.find(elms.chatDrawerLeftScoreValue).text(userScore);
        $drawer.find(elms.chatDrawerLeftScoreTimerValue).text(userTime);
        $drawer.find(elms.chatDrawerLeftTimeValue).text(userTime);

        $drawer
            .find(elms.chatDrawerRightPlayerAvatar)
            .attr("src", opponentAvatar)
            .attr("alt", opponentName);
        $drawer.find(elms.chatDrawerRightScoreValue).text(responseScore);
        $drawer.find(elms.chatDrawerRightScoreTimerValue).text(responseTime);
        $drawer.find(elms.chatDrawerRightTimeValue).text(responseTime);

        const $rightField = $drawer.find(elms.chatDrawerTopicFieldRight);
        const $rightPlayer = $drawer.find(elms.chatDrawerRightPlayer);
        const opponentId = cu?.ID != null ? Number(cu.ID) : null;
        const currentUserId =
            this._data?.profile?.ID != null
                ? Number(this._data.profile.ID)
                : null;
        const isCurrentUserChallenged =
            opponentId != null &&
            currentUserId != null &&
            opponentId === currentUserId;

        if (response == null) {
            $rightField.addClass("no-result");
            const pendingText = isCurrentUserChallenged
                ? `${this._data.home_page.timeline.extra_respond_button_label}`
                : `<b>${this.escapeHtml(opponentName)}</b> ${this._data.home_page.timeline.extra_pending_response_button_label}`;
            $drawer.find(elms.chatDrawerRightPlayerText).html(pendingText);
            if (isCurrentUserChallenged) {
                $rightPlayer.addClass(cls.isPlayer);
            }
        } else {
            const rightPlayerText =
                rightClass === "is-winner"
                    ? this.formatExtrasWinnerNameText(
                          opponentName,
                          extrasType,
                          themeURL,
                      )
                    : opponentName;
            if (rightClass === "is-winner") {
                $drawer
                    .find(elms.chatDrawerRightPlayerText)
                    .html(rightPlayerText);
            } else {
                $drawer
                    .find(elms.chatDrawerRightPlayerText)
                    .text(rightPlayerText);
            }
        }

        $drawer.find(elms.chatDrawerTopicFieldLeft).addClass(leftClass);
        $drawer.find(elms.chatDrawerTopicFieldRight).addClass(rightClass);
    }

    /**
     * Common: likes wrap state + count in the chat drawer.
     */
    populateChatDrawerLikes(item, $drawer) {
        const elms = this.elms;
        const cls = this.classes;
        const totalLikes = item.total_likes ?? "0";
        $drawer.find(elms.chatDrawerLikesCount).text(`${totalLikes} likes`);
        const $chatLikesWrap = $drawer.find(".subject-actions__likes");
        if (
            this._data?.home_page?.like_variants &&
            !$chatLikesWrap.find(".footer__likes__menu").length
        ) {
            $chatLikesWrap.prepend(this.buildLikeMenuHtml());
        }
        this.applyLikeWrapState(
            $chatLikesWrap,
            !!item.current_user_has_like,
            item.current_user_like_variant || null,
        );
        $chatLikesWrap
            .find(elms.chatLikeButton)
            .toggleClass(cls.hasLiked, !!item.current_user_has_like);
    }

    /**
     * Common: comments list (empty placeholder when there are none).
     */
    populateChatDrawerComments(item, $drawer, themeURL) {
        const elms = this.elms;
        const cls = this.classes;
        const comments = Array.isArray(item.comments) ? item.comments : [];
        const $list = $drawer.find(elms.chatDrawerList);
        $list.empty();
        if (comments.length === 0) {
            $list.append(
                `<li class="${cls.chatItem} ${cls.chatItemEmpty}">
                    <span class="${cls.chatMessage}">${this._data.home_page.timeline_detail.empty_reactions_label}</span>
                </li>`,
            );
            return;
        }
        comments.forEach((c) => {
            const user = c.user || {};
            const commentAvatar =
                user.avatar || `${themeURL}/assets/images/player.png`;
            const commentName = this.escapeHtml(user.display_name || "");
            const commentText = this.escapeHtml(c.comment || "");
            $list.append(
                `<li class="${cls.chatItem}">
                    <div class="${cls.chatUser}">
                        <img class="${cls.chatUserAvatar}" src="${commentAvatar}" alt="${commentName}" />
                        <span class="${cls.chatUserName}">${commentName}</span>
                    </div>
                    <span class="${cls.chatMessage}">${commentText}</span>
                </li>`,
            );
        });
    }

    escapeHtml(str) {
        if (str == null) return "";
        const div = document.createElement("div");
        div.textContent = str;
        return div.innerHTML;
    }

    /**
     * ACF "Challenge List - Subtitle" (`challenge_selection.list_subtitle`), same source as the challenge page.
     * Placeholders: `{theme}`, `{difficulty}`; optional `{days}` on timeline only.
     * Legacy `{subtheme}` in CMS copy is stripped to empty.
     *
     * @param {Record<string, unknown>} challengeData Timeline `challenge_data`
     * @returns {string} HTML safe for trusted template + escaped term names inside `<b>`
     */
    formatTimelineChallengeListSubtitle(challengeData) {
        const cd = challengeData || {};
        const pages = CONFIG.game?.pages ?? [];
        const room = pages.find(
            (p) => p.id === "challenge-page" || p.type === "challenge-page",
        );
        const raw =
            room?.data?.challenge_page?.challenge_selection?.list_subtitle;
        const template =
            typeof raw === "string" && raw.trim() !== ""
                ? raw
                : "I want to do something with {theme}, at a {difficulty} level.";

        const esc = (s) => this.escapeHtml(String(s ?? "").toLowerCase());
        const daysN = cd.days != null ? Number(cd.days) : NaN;
        const daysFragment =
            Number.isFinite(daysN) && daysN > 0
                ? ` for ${daysN} day${daysN === 1 ? "" : "s"} as an `
                : ` as an `;

        const replacements = {
            "{theme}": `<b>${esc(cd.theme)}</b>`,
            "{subtheme}": "",
            // "{subtheme}": `<b>${esc(cd.subtheme)}</b>`,
            "{difficulty}": `<b>${esc(cd.difficulty)}</b>`,
            "{days}": daysFragment,
        };

        return template.replace(
            /\{theme\}|\{subtheme\}|\{difficulty\}|\{days\}/g,
            (key) => replacements[key] || "",
        );
    }

    /**
     * Pause any video elements on the home page (timeline or chat drawer).
     */
    pauseAllVideos() {
        $(this.elms.homePage)
            .find("video")
            .each(function () {
                if (!this.paused) this.pause();
            });
    }

    /**
     * Close the timeline chat drawer when clicking outside of it.
     */
    attachChatDrawerOutsideClose() {
        $(document).off("click.chatDrawerOutside");
        setTimeout(() => {
            $(document).on("click.chatDrawerOutside", (e) => {
                const $drawer = $(this.elms.app).find(this.elms.chatDrawer);
                if (!$drawer.hasClass(this.classes.isOpen)) {
                    $(document).off("click.chatDrawerOutside");
                    return;
                }
                if ($(e.target).closest(this.elms.chatDrawer).length) {
                    return;
                }
                this.pauseAllVideos();
                $drawer.removeClass(this.classes.isOpen);
                $(document).off("click.chatDrawerOutside");
            });
        }, 0);
    }

    detachChatDrawerOutsideClose() {
        $(document).off("click.chatDrawerOutside");
    }

    onCloseChat(e) {
        e.preventDefault();
        this.detachChatDrawerOutsideClose();
        this.pauseAllVideos();
        $(this.elms.chatDrawer).removeClass(this.classes.isOpen);
    }

    updateChatSubmitState() {
        const $input = $(this.elms.chatCommentInput);
        const $submit = $(this.elms.chatCommentSubmit);
        const hasText = String($input.val() ?? "").trim().length > 0;
        $submit.prop("disabled", !hasText);
    }

    handleCommentKeydown(e) {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            this.handleCommentSubmit(e);
        }
    }

    async handleTimelineCommentKeydown(e) {
        if (e.key !== "Enter" || e.shiftKey) return;
        e.preventDefault();
        await this.submitInlineTimelineComment($(e.currentTarget));
    }

    async handleCommentSubmit(e) {
        e.preventDefault();
        const $drawer = $(this.elms.chatDrawer);
        const timelineId = $drawer.data("timeline-id");
        const teamId = this._teamId || localStorage.getItem("teamId");
        const $input = $(this.elms.chatCommentInput);
        const comment = String($input.val() ?? "").trim();
        if (!timelineId || !teamId || !comment) return;

        const c = await this.postTimelineComment(timelineId, comment);
        if (!c) return;
        const commentData = this.getCommentData(c);

        const $list = $drawer.find(this.elms.chatDrawerList);
        $list.find(`li.${this.classes.chatItemEmpty}`).remove();
        $list.append(this.buildDrawerCommentHtml(commentData));
        $input.val("");
        this.updateChatSubmitState();
        this.incrementTimelineReactionCount(timelineId);
    }

    handleVote(e) {
        e.preventDefault();
        $(this.elms.voteSection).addClass(this.classes.hasVoted);
    }

    handleDailyContent(e) {
        e.preventDefault();
        GameLogic.goToPage("challenge-page");
    }

    handleStoreClick(e) {
        e.preventDefault();
        GameLogic.goToPage("store-page");
        return;
    }

    handleManagerButtonClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const $dropdown = $(e.currentTarget).closest(this.elms.managerDropdown);
        const $menu = $dropdown.find(".home-page__header__dropdown__menu");
        const isOpen = $dropdown.hasClass(this.classes.isOpen);

        if (isOpen) {
            $dropdown.removeClass(this.classes.isOpen);
            $dropdown
                .find(this.elms.managerButton)
                .attr("aria-expanded", "false");
            $menu.attr("aria-hidden", "true");
        } else {
            $dropdown.addClass(this.classes.isOpen);
            $dropdown
                .find(this.elms.managerButton)
                .attr("aria-expanded", "true");
            $menu.attr("aria-hidden", "false");
            const closeDropdown = (e2) => {
                if ($dropdown.get(0).contains(e2.target)) return;
                $dropdown.removeClass(this.classes.isOpen);
                $dropdown
                    .find(this.elms.managerButton)
                    .attr("aria-expanded", "false");
                $menu.attr("aria-hidden", "true");
                $(document).off("click.managerDropdown", closeDropdown);
            };
            $(document).on("click.managerDropdown", closeDropdown);
        }
    }

    async handleManagerDropdownItemClick(e) {
        e.preventDefault();
        const action = $(e.currentTarget).data("action");
        const $dropdown = $(e.currentTarget).closest(this.elms.managerDropdown);
        $dropdown.removeClass(this.classes.isOpen);
        $dropdown.find(this.elms.managerButton).attr("aria-expanded", "false");
        $dropdown
            .find(".home-page__header__dropdown__menu")
            .attr("aria-hidden", "true");
        $(document).off("click.managerDropdown");

        if (action === "manager-menu") {
            GameLogic.goToPage("manager-page");
            return;
        }
        if (action === "logout") {
            $(this.elms.logoutPopupModal).addClass(this.classes.modalOpen);
            return;
        }
    }

    handleLogoutPopupCancelClick(e) {
        e.preventDefault();
        $(this.elms.logoutPopupModal).removeClass(this.classes.modalOpen);
    }

    async handleLogoutPopupConfirmClick(e) {
        e.preventDefault();
        $(this.elms.logoutPopupModal).removeClass(this.classes.modalOpen);
        const [res] = await bdjs.goAsync(bdapi.post("game/logout", {}));
        const redirectUrl =
            res?.data?.data?.redirect_url || CONFIG.homeURL || "/";
        window.location.href = redirectUrl;
    }

    onOpenTimelineItem() {
        this.pauseAllVideos();
        $(this.elms.chatDrawer).addClass(this.classes.isOpen);
        this.updateChatSubmitState();
        this.attachChatDrawerOutsideClose();
    }

    async fetchHomepageData() {
        const [res] = await bdjs.goAsync(
            bdapi.post("game/get-homepage-data", {
                team_id: this._teamId,
            }),
        );

        return res?.data?.data ?? [];
    }

    populateTimeline() {
        const timeline = this._data.timeline || [];
        const timelineList = $(this.elms.timelineList);
        const themeURL = CONFIG.themeURL || "";
        timelineList.empty();

        timeline.forEach((item) => {
            let timelineItem = null;

            if (item.type === "challenge") {
                timelineItem = this.renderTimelineChallengeItem(item, themeURL);
            } else if (item.type === "extras") {
                timelineItem = this.renderTimelineExtrasItem(item, themeURL);
            } else if (item.type === "store_weekly_kpi") {
                timelineItem = this.renderTimelineStoreWeeklyKpiItem(
                    item,
                    themeURL,
                );
            }

            if (timelineItem) {
                timelineList.append(timelineItem);
            }
        });
    }

    renderTimelineChallengeItem(item, themeURL) {
        const { status, status_label, challenge_data, user_data } = item;
        const cd = challenge_data || {};
        const ud = user_data || {};
        const title = cd.title || "";
        const currentAvatar =
            this._data.profile.avatar || `${themeURL}/assets/images/player.png`;
        const currentDisplayName = this._data.profile.display_name || "";
        const avatar = ud.avatar || `${themeURL}/assets/images/player.png`;
        const displayName = ud.display_name || "";
        const challengeStartSentence =
            this.formatTimelineChallengeListSubtitle(cd);

        const hasSubmission =
            item.submission != null &&
            item.submission.completion_type != null &&
            item.submission.completion_content != null;
        const submissionType = item.submission.completion_type || "";
        const contentClass = hasSubmission
            ? submissionType === "photo"
                ? "is-image-content"
                : submissionType === "video"
                  ? "is-video-content"
                  : "is-text-content"
            : "is-text-content";
        const topicContentHtml = (() => {
            if (!hasSubmission) return "";
            const content = item.submission.completion_content;
            if (submissionType === "text") {
                return `<div class="content__text">
                            <p>${this.escapeHtml(content)}</p>
                        </div>`;
            }
            if (submissionType === "photo") {
                return `<div class="content__media">
                            <img class="content__media__bg" src="${this.escapeHtml(content)}" alt="Challenge Media" />
                            <img class="content__media__image" src="${this.escapeHtml(content)}" alt="Challenge Media" />
                        </div>`;
            }
            if (submissionType === "video") {
                return `<div class="content__media">
                            <video class="content__media__video" controls>
                                <source src="${this.escapeHtml(content)}" type="video/mp4">
                            </video>
                        </div>`;
            }
            return "";
        })();
        const totalLikes = Number(item.total_likes || 0);
        const likeWrapClass = this.buildLikeWrapClassName(
            !!item.current_user_has_like,
            item.current_user_like_variant || null,
        );
        const likeMenuHtml = this.buildLikeMenuHtml();
        const likeIconsHtml = this.buildLikeButtonIconsHtml(themeURL);
        const comments = Array.isArray(item.comments) ? item.comments : [];
        const inlineCommentsHtml = comments
            .slice(0, 3)
            .map((comment) =>
                this.buildTimelineCommentHtml(this.getCommentData(comment)),
            )
            .join("");

        return status === "started"
            ? $(
                  `<li class="home-page__timeline__item is-player-challenge-start" data-timeline-id="${item.id}">
                <div class="timeline__item__tag">
                    <div class="timeline__item__tag__icon">
                        <img src="${themeURL}/assets/images/bullseye-arrow.svg" alt="Challenge" />
                    </div>
                    <span class="timeline__item__tag__title">Challenge</span>
                </div>
                <div class="timeline__item--section timeline-header">
                    <div class="header__player">
                        <div class="header__player__avatar">
                            <img src="${avatar}" alt="${displayName}" />
                        </div>
                        <span class="header__player__name">${displayName}</span>
                    </div>
                    <div class="header__challenge">
                        <span class="header__challenge__text">
                            ${challengeStartSentence}
                        </span>
                    </div>
                </div>
                <div class="timeline__item--section timeline-footer">
                    <div class="footer__likes ${likeWrapClass}">
                        ${likeMenuHtml}
                        <div class="footer__likes__display">
                            <button class="footer__likes__button">
                                ${likeIconsHtml}
                            </button>
                            <span class="footer__likes__count">${totalLikes} ${this._data.home_page.react}</span>
                        </div>
                    </div>
                    <div class="footer__comments">
                        <div class="footer__comments__list">${inlineCommentsHtml}</div>
                        <div class="footer__comments__input">
                            <div class="footer__comments__input__avatar">
                                <img src="${currentAvatar}" alt="${currentDisplayName}" />
                            </div>
                            <textarea class="footer__comments__input__textarea" placeholder="${this._data.home_page.comment_placeholder}"></textarea>
                            <div class="footer__comments__input__submit">
                                <button>
                                    <span>${this._data.home_page.submit_comment}</span>
                                    <img src="${themeURL}/assets/images/check.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </li>`,
              )
            : `<li class="home-page__timeline__item is-player-challenge-end" data-timeline-id="${item.id}">
            <div class="timeline__item--section timeline-status">
                <div class="status__players">
                    <div class="status__challenger">
                        <div class="status__challenger__avatar">
                            <img src="${avatar}" alt="${displayName}" />
                        </div>
                        <span class="status__challenger__name">${displayName}</span>
                        <span class="status__challenger__action">${status_label}</span>
                    </div>
                </div>
            </div>
            <div class="timeline__item--section timeline-content ${contentClass}">
                <span class="content__title">${title}</span>
                ${topicContentHtml}
            </div>
            <div class="timeline__item--section timeline-footer">
                <div class="footer__likes ${likeWrapClass}">
                    ${likeMenuHtml}
                    <div class="footer__likes__display">
                        <button class="footer__likes__button">
                            ${likeIconsHtml}
                        </button>
                        <span class="footer__likes__count">${totalLikes} ${this._data.home_page.react}</span>
                    </div>
                </div>
                <div class="footer__comments">
                    <div class="footer__comments__list">${inlineCommentsHtml}</div>
                    <div class="footer__comments__input">
                        <div class="footer__comments__input__avatar">
                            <img src="${currentAvatar}" alt="${currentDisplayName}" />
                        </div>
                        <textarea class="footer__comments__input__textarea" placeholder="${this._data.home_page.comment_placeholder}"></textarea>
                        <div class="footer__comments__input__submit">
                            <button>
                                <span>${this._data.home_page.submit_comment}</span>
                                <img src="${themeURL}/assets/images/check.svg" alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </li>`;
    }

    /**
     * @param {unknown} submission
     * @returns {Record<string, unknown>|null}
     */
    normalizeExtrasSubmission(submission) {
        if (submission == null) {
            return null;
        }
        if (typeof submission === "string") {
            try {
                const parsed = JSON.parse(submission);
                return typeof parsed === "object" && parsed != null
                    ? /** @type {Record<string, unknown>} */ (parsed)
                    : null;
            } catch {
                return null;
            }
        }
        if (typeof submission === "object") {
            return /** @type {Record<string, unknown>} */ (submission);
        }
        return null;
    }

    /**
     * Timeline row modifier: `is-race` | `is-quiz` | `is-question`.
     * @param {string|null|undefined} extrasType
     */
    getExtrasTimelineItemClass(extrasType) {
        const t = (extrasType || "").toString().toLowerCase();
        if (t === "race") {
            return "is-race";
        }
        if (t === "quiz") {
            return "is-quiz";
        }
        return "is-question";
    }

    /**
     * Chat subject modifier (matches `_home.scss` under `.home-page__chat__subject`).
     * @param {string|null|undefined} extrasType
     */
    getExtrasChatSubjectClass(extrasType) {
        const t = (extrasType || "").toString().toLowerCase();
        if (t === "race") {
            return this.classes.subjectTypeRace;
        }
        if (t === "quiz") {
            return this.classes.subjectTypeQuiz;
        }
        if (t === "question") {
            return this.classes.subjectTypeQuestion;
        }
        return this.classes.subjectTypeStatement;
    }

    /**
     * @param {object|null|undefined} item
     * @returns {{ leftClass: string, rightClass: string }}
     */
    getExtrasWinnerFieldClasses(item) {
        const ud = item?.user_data || {};
        const cu = item?.challenged_user || {};
        const challengerId = ud.ID != null ? Number(ud.ID) : null;
        const opponentId = cu.ID != null ? Number(cu.ID) : null;
        const winnerId =
            item?.winner_user_id != null && item.winner_user_id !== "0"
                ? Number(item.winner_user_id)
                : null;

        let leftClass = "";
        let rightClass = "";
        if (winnerId != null && winnerId > 0) {
            if (challengerId != null && winnerId === challengerId) {
                leftClass = "is-winner";
            }
            if (opponentId != null && winnerId === opponentId) {
                rightClass = "is-winner";
            }
        }

        return { leftClass, rightClass };
    }

    /**
     * @param {string} name
     * @param {string} extrasType
     * @param {string} [themeURL]
     * @returns {string}
     */
    formatExtrasWinnerNameText(name, extrasType, themeURL) {
        const template =
            this._data?.home_page?.timeline?.extra_winner_name_text_label ||
            "{name}";
        const type = (extrasType || "").toString();
        const typeLabel = type
            ? type.charAt(0).toUpperCase() + type.slice(1)
            : "";
        const nameWithTrophy = themeURL
            ? `<b>${name ?? ""}<img class="item-challenge__field__player__trophy-icon" src="${this.escapeHtml(`${themeURL}/assets/images/trophy.svg`)}" alt="" aria-hidden="true" /></b>`
            : `<b>${name ?? ""} 🏆</b>`;

        return template
            .replace("{name}", nameWithTrophy)
            .replace("{type}", typeLabel);
    }

    /**
     * @param {number|null|undefined} sec
     * @returns {string}
     */
    formatQuizCompletionTimeSec(sec) {
        const n = Number(sec);
        if (!Number.isFinite(n) || n < 0) {
            return "";
        }
        const m = Math.floor(n / 60);
        const s = Math.floor(n % 60);
        if (m === 0) {
            return `${s}s`;
        }
        return `${m}m${s}s`;
    }

    /**
     * @param {number|null|undefined} sec
     * @returns {string}
     */
    formatRaceCompletionTimeSec(sec) {
        const n = Number(sec);
        if (!Number.isFinite(n) || n < 0) {
            return "";
        }
        const mm = Math.floor(n / 60);
        const ss = Math.floor(n % 60);
        return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
    }

    renderTimelineExtrasItem(item, themeURL) {
        const { extra_data, user_data, challenged_user, submission, response } =
            item || {};
        const ed = extra_data || {};
        const ud = user_data || {};
        const cu = challenged_user || {};
        const avatar = ud.avatar || `${themeURL}/assets/images/player.png`;
        const displayName = ud.display_name || "";
        const challengedAvatar =
            cu.avatar || `${themeURL}/assets/images/player.png`;
        const challengedDisplayName = cu.display_name || "";
        const title = ed.title || "";
        const currentAvatar =
            this._data.profile.avatar || `${themeURL}/assets/images/player.png`;
        const currentDisplayName = this._data.profile.display_name || "";
        const extrasType = ed.type || "";
        const timelineItemClass = this.getExtrasTimelineItemClass(extrasType);
        const userSubmission =
            extrasType === "question"
                ? submission?.answer
                : extrasType === "quiz"
                  ? submission?.answer?.__quizSummary
                  : extrasType === "race"
                    ? submission?.answer?.__raceSummary
                    : null;
        const responseSubmission =
            extrasType === "question"
                ? response?.answer
                : extrasType === "quiz"
                  ? response?.answer?.__quizSummary
                  : extrasType === "race"
                    ? response?.answer?.__raceSummary
                    : null;
        const responseClassQuestion =
            response != null
                ? "has-answered"
                : this._data.profile.ID === cu.ID
                  ? "is-player"
                  : "";
        const responseContentQuestion =
            response != null
                ? extrasType === "question"
                    ? response?.answer
                    : extrasType === "quiz" || extrasType === "race"
                      ? challengedDisplayName
                      : response?.answer
                : this._data.profile.ID === cu.ID
                  ? `${this._data.home_page.timeline.extra_respond_button_label}`
                  : `<b>${challengedDisplayName}</b> ${this._data.home_page.timeline.extra_pending_response_button_label}`;
        const responseClassQuizRace = response === null ? "no-result" : "";
        const responseClassIsPlayer =
            !response && this._data.profile.ID === cu.ID ? "is-player" : "";
        const formatExtrasCompletionTime = (sec) => {
            if (extrasType === "quiz") {
                return this.formatQuizCompletionTimeSec(sec);
            }
            if (extrasType === "race") {
                return this.formatRaceCompletionTimeSec(sec);
            }
            return sec != null && sec !== "" ? String(sec) : "";
        };
        const userCompletionTimeDisplay = formatExtrasCompletionTime(
            userSubmission?.completionTimeSec,
        );
        const responseCompletionTimeDisplay = formatExtrasCompletionTime(
            responseSubmission?.completionTimeSec,
        );
        const formatExtrasScoreValue = (summary) => {
            if (extrasType === "quiz") {
                return summary?.totalPoints != null ? summary.totalPoints : "";
            }
            if (extrasType === "race") {
                return formatExtrasCompletionTime(summary?.completionTimeSec);
            }
            return "";
        };
        const userScoreValue = formatExtrasScoreValue(userSubmission);
        const responseScoreValue = formatExtrasScoreValue(responseSubmission);
        const userQuestionText =
            extrasType === "question"
                ? this.escapeHtml(String(submission?.answer ?? ""))
                : "";
        const questionPromptText =
            extrasType === "question"
                ? this.escapeHtml(String(ed.question ?? ""))
                : "";
        const pointsValue =
            item.points_earned != null ? Number(item.points_earned) : 0;
        const pointsLabel = pointsValue > 0 ? `+${pointsValue}` : "+50";
        const { file, label } = this.getExtrasTypeDisplay(extrasType);
        const iconUrl = this.escapeHtml(`${themeURL}/assets/images/${file}`);
        const totalLikes = Number(item.total_likes || 0);
        const likeWrapClass = this.buildLikeWrapClassName(
            !!item.current_user_has_like,
            item.current_user_like_variant || null,
        );
        const likeMenuHtml = this.buildLikeMenuHtml();
        const likeIconsHtml = this.buildLikeButtonIconsHtml(themeURL);
        const comments = Array.isArray(item.comments) ? item.comments : [];
        const inlineCommentsHtml = comments
            .slice(0, 3)
            .map((comment) =>
                this.buildTimelineCommentHtml(this.getCommentData(comment)),
            )
            .join("");
        const extraChallengedLabel =
            this._data.home_page.timeline.extra_challenged_label ||
            "challenged";
        let extraToLabel =
            this._data.home_page.timeline.extra_challenged_suffix_label ||
            "to a {type}";
        extraToLabel = extraToLabel.replace("{type}", extrasType);
        const { leftClass: leftWinnerClass, rightClass: rightWinnerClass } =
            this.getExtrasWinnerFieldClasses(item);
        const leftPlayerName =
            leftWinnerClass === "is-winner"
                ? this.formatExtrasWinnerNameText(
                      displayName,
                      extrasType,
                      themeURL,
                  )
                : displayName;
        const rightPlayerText =
            rightWinnerClass === "is-winner"
                ? this.formatExtrasWinnerNameText(
                      responseContentQuestion,
                      extrasType,
                      themeURL,
                  )
                : responseContentQuestion;

        const $inner = `<li class="home-page__timeline__item ${timelineItemClass}" data-timeline-id="${item.id}" data-extras-type="${extrasType}">
						<div class="timeline__item--section timeline-status">
							<div class="status__players">
								<div class="status__challenger">
									<div class="status__challenger__avatar">
										<img src="${avatar}" alt="${displayName}" />
									</div>
									<span class="status__challenger__name">${displayName}</span>
									<span class="status__challenger__action">${extraChallengedLabel}</span>
								</div>
								<div class="status__opponent">
									<div class="status__opponent__avatar">
										<img src="${challengedAvatar}" alt="${challengedDisplayName}" />
									</div>
									<span class="status__opponent__name">${challengedDisplayName}</span>
									<span class="status__opponent__action">${extraToLabel}</span>
								</div>
							</div>
							<div class="status__points">
								<div class="status__points__icon">
                                    <img src="${themeURL}/assets/images/points.svg" alt="Points" />
								</div>
								<span class="status__points__value">${pointsLabel}</span>
							</div>
						</div>
						<div class="timeline__item--section timeline-challenge">
							<div class="item-challenge">
								<div class="item-challenge__tag">
									<div class="item-challenge__tag__icon">
                                        <img src="${iconUrl}" alt="${label}" />
									</div>
									<span class="item-challenge__tag__title">${extrasType.toUpperCase()}</span>
								</div>
								<h3 class="item-challenge__title">${title}</h3>
								<div class="item-challenge__content">
									${
                                        extrasType === "question" &&
                                        questionPromptText
                                            ? `<p class="item-challenge__prompt">${questionPromptText}</p>`
                                            : ""
                                    }
									<div class="item-challenge__question">
										<img class="item-challenge__question__image" src="${avatar}" alt="${displayName}" />
										<span class="item-challenge__question__text">${userQuestionText}</span>
									</div>
									<div class="item-challenge__respond ${responseClassQuestion}">
										<img class="item-challenge__respond__image" src="${challengedAvatar}" alt="${challengedDisplayName}" />
										<span class="item-challenge__respond__text">${responseContentQuestion}</span>
										<textarea class="item-challenge__respond__textarea" rows="4" placeholder="Your answer"></textarea>
										<button class="item-challenge__respond__submit">
											<span>${this._data.home_page.submit_comment}</span>
											<img src="${themeURL}/assets/images/check.svg" alt="Check" />
										</button>
									</div>
									<div class="item-challenge__field">
										<div class="item-challenge__field--left ${leftWinnerClass}">
											<div class="item-challenge__field__trophy">
												<img src="${themeURL}/assets/images/trophy-big.svg" alt="Trophy" />
											</div>
											<div class="item-challenge__field__player player-left">
												<img class="item-challenge__field__player__avatar" src="${avatar}" alt="${displayName}" />
												<span class="item-challenge__field__player__name">${leftPlayerName}</span>
											</div>
											<div class="item-challenge__field__score">
												<span class="item-challenge__field__score__text">${this._data.home_page.timeline.extra_total_points_label}</span>
												<span class="item-challenge__field__score__value">${userScoreValue}</span>
												<div class="item-challenge__field__score__timer">
													<div class="item-challenge__field__score__timer__icon">
														<img src="${themeURL}/assets/images/timer.svg" alt="Timer" />
													</div>
													<span class="item-challenge__field__score__timer__value">${userCompletionTimeDisplay}</span>
												</div>
											</div>
											<div class="item-challenge__field__time">
												<span class="item-challenge__field__time__text">${this._data.home_page.timeline.extra_time_spent_label}</span>
												<div class="item-challenge__field__time__wrapper">
													<div class="item-challenge__field__time__icon">
														<img src="${themeURL}/assets/images/timer.svg" alt="Timer" />
													</div>
													<span class="item-challenge__field__time__value">${userCompletionTimeDisplay}</span>
												</div>
											</div>
										</div>
										<div class="item-challenge__versus">
											<span class="item-challenge__versus__text">VS</span>
										</div>
										<div class="item-challenge__field--right ${responseClassQuizRace} ${rightWinnerClass}">
											<div class="item-challenge__field__trophy">
												<img src="${themeURL}/assets/images/trophy-big.svg" alt="Trophy" />
											</div>
											<div class="item-challenge__field__player player-right ${responseClassIsPlayer}">
												<img class="item-challenge__field__player__avatar" src="${challengedAvatar}" alt="${challengedDisplayName}" />
												<span class="item-challenge__field__player__text">${rightPlayerText}</span>
											</div>
											<div class="item-challenge__field__score">
												<span class="item-challenge__field__score__text">${this._data.home_page.timeline.extra_total_points_label}</span>
												<span class="item-challenge__field__score__value">${responseScoreValue}</span>
												<div class="item-challenge__field__score__timer">
													<div class="item-challenge__field__score__timer__icon">
														<img src="${themeURL}/assets/images/timer.svg" alt="Timer" />
													</div>
													<span class="item-challenge__field__score__timer__value">${responseCompletionTimeDisplay}</span>
												</div>
											</div>
											<div class="item-challenge__field__time">
												<span class="item-challenge__field__time__text">${this._data.home_page.timeline.extra_time_spent_label}</span>
												<div class="item-challenge__field__time__wrapper">
													<div class="item-challenge__field__time__icon">
														<img src="${themeURL}/assets/images/timer.svg" alt="Timer" />
													</div>
													<span class="item-challenge__field__time__value">${responseCompletionTimeDisplay}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="timeline__item--section timeline-actions">
							<div class="footer__likes ${likeWrapClass}">
                                ${likeMenuHtml}
								<div class="footer__likes__display">
									<button class="footer__likes__button">
                                        ${likeIconsHtml}
									</button>
                                    <span class="footer__likes__count">${totalLikes} ${this._data.home_page.react}</span>
								</div>
							</div>
						</div>
						<div class="timeline__item--section timeline-comments">
							<div class="footer__comments">
								<div class="footer__comments__list">${inlineCommentsHtml}</div>
                                <div class="footer__comments__input">
                                    <div class="footer__comments__input__avatar">
                                        <img src="${currentAvatar}" alt="${currentDisplayName}" />
                                    </div>
                                    <textarea class="footer__comments__input__textarea" placeholder="${this._data.home_page.comment_placeholder}"></textarea>
                                    <div class="footer__comments__input__submit">
                                        <button>
                                            <span>${this._data.home_page.submit_comment}</span>
                                            <img src="${themeURL}/assets/images/check.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
							</div>
						</div>
					</li>`;

        return $($inner);
    }

    renderTimelineStoreWeeklyKpiItem(item, themeURL) {
        if (!item || item.type !== "store_weekly_kpi") {
            return null;
        }

        const avatar =
            this._data.profile.avatar || `${themeURL}/assets/images/player.png`;
        const weeklyStoreKpi =
            item.weekly_store_kpi ||
            (() => {
                try {
                    return item.meta_content
                        ? JSON.parse(item.meta_content)
                        : {};
                } catch (error) {
                    return {};
                }
            })();
        const periods = weeklyStoreKpi.periods || {};
        const metrics = weeklyStoreKpi.metrics || {};
        const lastWeek = periods.last_week || {};
        const currentWeek = lastWeek.iso_week != null ? lastWeek.iso_week : "";
        const statusLabel = item.status_label || "Weekly Statistics";
        const storeName = this.escapeHtml(
            item?.user_data?.display_name || "Store",
        );
        const totalLikes = Number(item.total_likes || 0);
        const likeWrapClass = this.buildLikeWrapClassName(
            !!item.current_user_has_like,
            item.current_user_like_variant || null,
        );
        const likeMenuHtml = this.buildLikeMenuHtml();
        const likeIconsHtml = this.buildLikeButtonIconsHtml(themeURL);
        const comments = Array.isArray(item.comments) ? item.comments : [];
        const inlineCommentsHtml = comments
            .slice(0, 3)
            .map((comment) =>
                this.buildTimelineCommentHtml(this.getCommentData(comment)),
            )
            .join("");

        const formatPercent = (value) => {
            if (!Number.isFinite(Number(value))) return "0.0";
            return Math.abs(Number(value)).toFixed(1);
        };
        const formatMetricValue = (value) => {
            if (!Number.isFinite(Number(value))) {
                return { integerPart: "0", decimalPart: ".00" };
            }
            const formatted = Number(value).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            const [integerPart, decimalPart = "00"] = formatted.split(".");
            return { integerPart, decimalPart: `.${decimalPart}` };
        };
        const metricItems = [
            { key: "apt", title: "APT" },
            { key: "opt", title: "OPT" },
            { key: "omzet", title: "Omzet" },
        ].map(({ key, title }) => {
            const metric = metrics[key] || {};
            const trend = metric.trend === "down" ? "decrease" : "increase";
            const percent = formatPercent(metric.percent_change);
            const valueParts = formatMetricValue(metric.current_value);
            return { key, title, trend, percent, valueParts };
        });

        const metricHtml = metricItems
            .map(
                (
                    metric,
                ) => `<div class="header__stats__item ${metric.trend} stat-${metric.key}">
                                    <div class="header__stats__item__info">
                                        <span class="header__stats__item__title">${metric.title}</span>
                                        <div class="header__stats__item__change">
                                            <div class="header__stats__item__change__icon">
                                                <img src="${themeURL}/assets/images/angle-up.svg" alt="" />
                                            </div>
                                            <span class="header__stats__item__change__value">${metric.percent}<sup>%</sup></span>
                                        </div>
                                    </div>
                                    <div class="header__stats__item__value">
                                        <span><sup>€</sup>${metric.valueParts.integerPart}<sub>${metric.valueParts.decimalPart}</sub></span>
                                    </div>
                                </div>`,
            )
            .join("");

        return $(
            `<li class="home-page__timeline__item is-stats" data-timeline-id="${item.id}">
                <div class="timeline__item--section timeline-header">
                    <div class="header__head">
                        <div class="header__head__image">
                            <img src="${themeURL}/assets/images/gall-admin.png" alt="stats" />
                        </div>
                        <span class="header__head__title">${this.escapeHtml(statusLabel)}: Week ${currentWeek}</span>
                    </div>
                    <div class="header__stats">
                        ${metricHtml}
                    </div>
                </div>
                <div class="timeline__item--section timeline-footer">
                    <div class="footer__likes ${likeWrapClass}">
                        ${likeMenuHtml}
                        <div class="footer__likes__display">
                            <button class="footer__likes__button">
                                ${likeIconsHtml}
                            </button>
                            <span class="footer__likes__count">${totalLikes} ${this._data.home_page.react}</span>
                        </div>
                    </div>
                    <div class="footer__comments">
                        <div class="footer__comments__list">${inlineCommentsHtml}</div>
                        <div class="footer__comments__input">
                            <div class="footer__comments__input__avatar">
                                <img src="${avatar}" alt="${storeName}" />
                            </div>
                            <textarea class="footer__comments__input__textarea" placeholder="${this._data.home_page.comment_placeholder}"></textarea>
                            <div class="footer__comments__input__submit">
                                <button>
                                    <span>${this._data.home_page.submit_comment}</span>
                                    <img src="${themeURL}/assets/images/check.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </li>`,
        );
    }

    handleViewDashboardClick(e) {
        e.preventDefault();
        GameLogic.goToPage("overview-page");
    }

    handleTimelineTextareaClick(e) {
        const $textarea = $(e.currentTarget);
        const $wrapper = $textarea.closest(this.elms.timelineInputSection);
        $wrapper.addClass(this.classes.isActive);
        const ns = ".timelineCommentInput";
        $(document)
            .off(`click${ns}`)
            .on(`click${ns}`, (event) => {
                if (
                    !$wrapper.get(0)?.contains(event.target) &&
                    !$textarea.val().trim()
                ) {
                    $wrapper.removeClass(this.classes.isActive);
                }
            });
    }

    async submitInlineTimelineComment($textarea) {
        const $item = $textarea.closest(this.elms.timelineItem);
        const timelineId = $item.data("timeline-id");
        const comment = ($textarea.val() || "").trim();
        if (!timelineId || !comment) return;

        const c = await this.postTimelineComment(timelineId, comment);
        if (!c) return;

        const $list = $item.find(this.elms.timelineCommentList).first();
        const commentData = this.getCommentData(c);
        $list.append(this.buildTimelineCommentHtml(commentData));
        $textarea.val("");
        this.incrementTimelineReactionCount(timelineId);
    }

    async postTimelineComment(timelineId, comment) {
        const teamId = this._teamId || localStorage.getItem("teamId");
        if (!timelineId || !teamId || !comment) return null;
        const [res] = await bdjs.goAsync(
            bdapi.post("game/timeline-comment", {
                team_id: teamId,
                timeline_id: timelineId,
                comment,
            }),
        );
        const c = res?.data?.data;
        if (!res?.data?.success || !c) return null;
        return c;
    }

    getCommentData(comment) {
        const themeURL = CONFIG.themeURL || "";
        const user = comment?.user || {};
        return {
            avatar: user.avatar || `${themeURL}/assets/images/player.png`,
            name: this.escapeHtml(user.display_name || ""),
            text: this.escapeHtml(comment?.comment || ""),
        };
    }

    buildDrawerCommentHtml(commentData) {
        return `<li class="${this.classes.chatItem}">
            <div class="${this.classes.chatUser}">
                <img class="${this.classes.chatUserAvatar}" src="${commentData.avatar}" alt="${commentData.name}" />
                <span class="${this.classes.chatUserName}">${commentData.name}</span>
            </div>
            <span class="${this.classes.chatMessage}">${commentData.text}</span>
        </li>`;
    }

    buildTimelineCommentHtml(commentData) {
        return `<div class="footer__comments__item">
            <div class="footer__comments__item__player">
                <img class="footer__comments__item__avatar" src="${commentData.avatar}" alt="${commentData.name}" />
                <span class="footer__comments__item__name">${commentData.name}</span>
            </div>
            <span class="footer__comments__item__content">${commentData.text}</span>
        </div>`;
    }

    incrementTimelineReactionCount(timelineId) {
        const $reactionsCount = $(
            `.actions__reactions[data-timeline-id="${timelineId}"]`,
        ).find(this.elms.actionsReactionsCount);
        if (!$reactionsCount.length) return;
        const current = $reactionsCount.text().replace(/\D/g, "") || "0";
        $reactionsCount.text(`${parseInt(current, 10) + 1} reactions`);
    }

    getLikeWrap($elm) {
        return $elm.closest(this.elms.likeWrap);
    }

    getTimelineIdFromWrap($wrap) {
        if (!$wrap?.length) return null;

        if ($wrap.hasClass("subject-actions__likes")) {
            return Number($(this.elms.chatDrawer).data("timeline-id")) || null;
        }

        if ($wrap.hasClass("actions__likes")) {
            return Number($wrap.data("timeline-id")) || null;
        }

        if ($wrap.hasClass("footer__likes")) {
            return (
                Number(
                    $wrap.closest(this.elms.timelineItem).data("timeline-id"),
                ) || null
            );
        }

        return null;
    }

    getVariantFromOption($option) {
        const className = ($option.attr("class") || "").split(/\s+/);
        const optionClass = className.find((name) =>
            name.startsWith("option-"),
        );
        if (!optionClass) return null;
        const variant = optionClass.replace("option-", "");
        return this.likeVariants.includes(variant) ? variant : null;
    }

    getVariantClassList() {
        return [
            this.classes.isDefault,
            this.classes.isCheers,
            this.classes.isSuccess,
            this.classes.isLekkerBezig,
            this.classes.isVerfrissend,
            this.classes.isLekkerLeren,
            this.classes.isAmazing,
        ];
    }

    getVariantClassName(variant) {
        if (!variant || !this.likeVariants.includes(variant)) {
            return this.classes.isDefault;
        }

        return `is-${variant}`;
    }

    buildLikeWrapClassName(liked, variant) {
        const classes = [this.getVariantClassName(variant)];
        if (liked) {
            classes.push(this.classes.hasLiked);
        }
        return classes.join(" ");
    }

    buildLikeMenuHtml() {
        const likeVariants = this._data.home_page.like_variants;
        return `<div class="footer__likes__menu">
            <button class="like-option option-cheers">
                <div class="like-option__icon"><img src="${likeVariants.cheers.icon}" alt="" /></div>
                <span class="like-option__title">${likeVariants.cheers.text}</span>
            </button>
            <button class="like-option option-success">
                <div class="like-option__icon"><img src="${likeVariants.success.icon}" alt="" /></div>
                <span class="like-option__title">${likeVariants.success.text}</span>
            </button>
            <button class="like-option option-lekker-bezig">
                <div class="like-option__icon"><img src="${likeVariants.nice_going.icon}" alt="" /></div>
                <span class="like-option__title">${likeVariants.nice_going.text}</span>
            </button>
            <button class="like-option option-verfrissend">
                <div class="like-option__icon"><img src="${likeVariants.refreshing.icon}" alt="" /></div>
                <span class="like-option__title">${likeVariants.refreshing.text}</span>
            </button>
            <button class="like-option option-lekker-leren">
                <div class="like-option__icon"><img src="${likeVariants.great_learning.icon}" alt="" /></div>
                <span class="like-option__title">${likeVariants.great_learning.text}</span>
            </button>
            <button class="like-option option-amazing">
                <div class="like-option__icon"><img src="${likeVariants.amazing.icon}" alt="" /></div>
                <span class="like-option__title">${likeVariants.amazing.text}</span>
            </button>
        </div>`;
    }

    buildLikeButtonIconsHtml(themeURL) {
        const likeVariants = this._data.home_page.like_variants;
        return `<div class="footer__likes__button__icon icon-default"><img src="${themeURL}/assets/images/thumbs-up.svg" alt="" /></div>
            <div class="footer__likes__button__icon icon-cheers"><img src="${likeVariants.cheers.icon}" alt="" /></div>
            <div class="footer__likes__button__icon icon-success"><img src="${likeVariants.success.icon}" alt="" /></div>
            <div class="footer__likes__button__icon icon-lekker-bezig"><img src="${likeVariants.nice_going.icon}" alt="" /></div>
            <div class="footer__likes__button__icon icon-verfrissend"><img src="${likeVariants.refreshing.icon}" alt="" /></div>
            <div class="footer__likes__button__icon icon-lekker-leren"><img src="${likeVariants.great_learning.icon}" alt="" /></div>
            <div class="footer__likes__button__icon icon-amazing"><img src="${likeVariants.amazing.icon}" alt="" /></div>`;
    }

    applyLikeWrapState($wrap, liked, variant) {
        if (!$wrap?.length) return;

        $wrap.removeClass(this.getVariantClassList().join(" "));
        $wrap.removeClass(this.classes.isMenuOpen);
        $wrap.toggleClass(this.classes.hasLiked, liked);
        $wrap.addClass(this.getVariantClassName(variant));
    }

    async toggleLikeForWrap($wrap) {
        const timelineId = this.getTimelineIdFromWrap($wrap);
        const teamId = this._teamId || localStorage.getItem("teamId");
        if (!timelineId || !teamId) return;

        const hasLiked = $wrap.hasClass(this.classes.hasLiked);
        const endpoint = hasLiked
            ? "game/timeline-unlike"
            : "game/timeline-like";
        const [res] = await bdjs.goAsync(
            bdapi.post(endpoint, { team_id: teamId, timeline_id: timelineId }),
        );
        const data = res?.data?.data;
        if (!res?.data?.success || data == null) return;
        const newCount =
            data.total_likes != null ? data.total_likes : hasLiked ? 0 : 1;

        const variant = data.variant || null;
        this.syncTimelineLikeState(timelineId, !!data.liked, newCount, variant);
    }

    async likeTimelineWithVariant(timelineId, variant) {
        const teamId = this._teamId || localStorage.getItem("teamId");
        if (!timelineId || !teamId) return;

        const [res] = await bdjs.goAsync(
            bdapi.post("game/timeline-like", {
                team_id: teamId,
                timeline_id: timelineId,
                variant,
            }),
        );
        const data = res?.data?.data;
        if (!res?.data?.success || data == null) return;

        const newCount = data.total_likes != null ? data.total_likes : 0;
        const selectedVariant = data.variant || variant || null;
        this.syncTimelineLikeState(
            timelineId,
            !!data.liked,
            newCount,
            selectedVariant,
        );
    }

    syncTimelineLikeState(timelineId, liked, likeCount, variant = null) {
        const $drawer = $(this.elms.chatDrawer);
        const drawerTimelineId = Number($drawer.data("timeline-id")) || null;
        const targetTimelineId = Number(timelineId) || null;
        if (
            $drawer.hasClass(this.classes.isOpen) &&
            drawerTimelineId != null &&
            targetTimelineId != null &&
            drawerTimelineId === targetTimelineId
        ) {
            $drawer
                .find(this.elms.chatDrawerLikesCount)
                .text(`${likeCount} likes`);
            const $drawerWrap = $drawer.find(".subject-actions__likes");
            this.applyLikeWrapState($drawerWrap, liked, variant);
            $drawerWrap
                .find(this.elms.chatLikeButton)
                .toggleClass(this.classes.hasLiked, liked);
        }

        const $actionLikes = $(
            `.actions__likes[data-timeline-id="${timelineId}"]`,
        );
        $actionLikes.find(".actions__likes__count").text(`${likeCount} likes`);
        this.applyLikeWrapState($actionLikes, liked, variant);
        $actionLikes
            .find(".actions__likes__button")
            .toggleClass(this.classes.hasLiked, liked);

        const $footerLikes = $(
            `${this.elms.timelineItem}[data-timeline-id="${timelineId}"] .footer__likes`,
        );
        this.applyLikeWrapState($footerLikes, liked, variant);
        $footerLikes.find(".footer__likes__count").text(`${likeCount} reacted`);
    }

    // ----- In-app notifications (full-screen overlay) -----

    closeNotificationsOverlay() {
        const $o = $(this.elms.app).find(this.elms.notificationsOverlay);
        if (!$o.length) return;
        $o.off("click.notifBackdrop");
        $o.removeClass(this.classes.notifOverlayOpen);
        $o.attr("aria-hidden", "true");
        $(this.elms.app)
            .find(this.elms.notifOpenButton)
            .attr("aria-expanded", "false");
    }

    /**
     * Dismiss when clicking the dimmed full-screen area: outside `.home-page__notifications`
     * (clicks on the panel stay open; the overlay element covers the whole screen).
     */
    attachNotificationBackdropClose() {
        const $o = $(this.elms.app).find(this.elms.notificationsOverlay);
        if (!$o.length) return;
        $o.off("click.notifBackdrop");
        $o.on("click.notifBackdrop", (e) => {
            if (!$(e.target).closest(this.elms.notifPanel).length) {
                this.closeNotificationsOverlay();
            }
        });
    }

    updateNotificationBadgeCount(count) {
        const n = Math.max(0, Number(count) || 0);
        const $btn = $(this.elms.app).find(this.elms.notifOpenButton);
        if (!$btn.length) return;
        let $wrap = $btn.find("[data-role='notif-badge-wrap']");
        if (n > 0) {
            const label = n > 99 ? "99+" : String(n);
            if (!$wrap.length) {
                $btn.append(
                    `<div class="notification-count" data-role="notif-badge-wrap"><span data-role="notif-badge">${label}</span></div>`,
                );
            } else {
                $wrap.find("[data-role='notif-badge']").text(label);
            }
        } else {
            $wrap.remove();
        }
    }

    getNotificationItemModifierClass(n) {
        const t = n?.notification_type;
        if (t === "timeline_comment") {
            return "is-comment";
        }
        if (t === "timeline_like") {
            return "is-reaction";
        }
        if (t === "extras_challenge") {
            const e = (n?.payload?.extras_type || "").toString().toLowerCase();
            if (e === "quiz") {
                return "is-quiz";
            }
            if (e === "race") {
                return "is-race";
            }
            return "is-question";
        }
        return "is-comment";
    }

    /**
     * Timeline / REST variant slug → key in PHP `home_page.like_variants`
     * (matches option-lekker-bezig → nice_going, etc. in buildLikeMenuHtml).
     *
     * @param {string|null|undefined} variant
     * @returns {string|null}
     */
    mapTimelineVariantToLikeConfigKey(variant) {
        const v = (variant || "").toString().toLowerCase();
        const map = {
            cheers: "cheers",
            success: "success",
            "lekker-bezig": "nice_going",
            verfrissend: "refreshing",
            "lekker-leren": "great_learning",
            amazing: "amazing",
        };
        return map[v] ?? null;
    }

    /**
     * Icon URL and label from ACF `like__*` options via `Config::home_page_config().like_variants`.
     *
     * @param {string|null|undefined} variant
     * @returns {{ iconUrl: string, label: string }}
     */
    getNotificationVariantDisplay(variant) {
        const themeURL = CONFIG.themeURL || "";
        const key = this.mapTimelineVariantToLikeConfigKey(variant);
        const variants = this._data?.home_page?.like_variants;
        if (key && variants && typeof variants === "object" && variants[key]) {
            const row = variants[key];
            const iconUrl = (row.icon || "").toString().trim();
            const label = (row.text || "").toString().trim();
            if (iconUrl || label) {
                return {
                    iconUrl:
                        iconUrl || `${themeURL}/assets/images/thumbs-up.svg`,
                    label: label || "Reacted",
                };
            }
        }
        const fallbackFile = "thumbs-up.svg";
        return {
            iconUrl: `${themeURL}/assets/images/${fallbackFile}`,
            label: "Reacted",
        };
    }

    getExtrasTypeDisplay(et) {
        const e = (et || "").toString().toLowerCase();
        if (e === "quiz") {
            return { file: "head-side-brain.svg", label: "Quiz" };
        }
        if (e === "race") {
            return { file: "flag-checkered.svg", label: "Race" };
        }
        if (e === "question" || e === "all" || e === "statement") {
            return {
                file: "question.svg",
                label: e === "all" ? "Extra" : "Question",
            };
        }
        return {
            file: "question.svg",
            label: e ? e.charAt(0).toUpperCase() + e.slice(1) : "Extra",
        };
    }

    buildNotificationItemHtml(n) {
        const themeURL = CONFIG.themeURL || "";
        const mod = this.getNotificationItemModifierClass(n);
        const id = n.id;
        const tid = n.timeline_id || 0;
        const actor = n.actor || {};
        const name = this.escapeHtml(actor.display_name || "Someone");
        const rawAvatar =
            actor.avatar || `${themeURL}/assets/images/player.png`;
        const avatar = this.escapeHtml(rawAvatar);
        const type = n.notification_type;
        const p = n.payload || {};
        const nameAlt = this.escapeHtml(actor.display_name || "");
        const avatarTag = `<img class="notification__content__avatar" src="${avatar}" alt="${nameAlt}" />`;
        const message = this.escapeHtml(n.message || "");
        let middle = "";
        let messageBlock = "";

        if (type === "timeline_comment") {
            middle = `${avatarTag}<span class="notification__content__status"><b class="notification__content__name">${name}</b> ${message}</span>`;
            const prev = p.comment_preview ? String(p.comment_preview) : "";
            if (prev) {
                messageBlock = `<div class="notification__content__message"><p>“${this.escapeHtml(prev)}”</p></div>`;
            }
        } else if (type === "timeline_like") {
            const { iconUrl, label } = this.getNotificationVariantDisplay(
                p.variant,
            );
            const isDefault = p.variant === "";
            let invertClass = "";
            if (isDefault) {
                invertClass = "style='filter: invert(1)'";
            }
            const safeIcon = this.escapeHtml(iconUrl);
            middle = `${avatarTag}<span class="notification__content__status"><b class="notification__content__name">${name}</b> ${message}</span>
      <div class="notification__content__tag">
        <div class="notification__content__icon"><img ${invertClass} src="${safeIcon}" alt="" /></div>
        <span class="notification__content__tag-name">${this.escapeHtml(label)}</span>
      </div>`;
        } else if (type === "extras_challenge") {
            const et = (p.extras_type || "").toString().toLowerCase();
            const { file, label } = this.getExtrasTypeDisplay(et);
            const iconUrl = this.escapeHtml(
                `${themeURL}/assets/images/${file}`,
            );
            middle = `${avatarTag}<span class="notification__content__status"><b class="notification__content__name">${name}</b> ${message}</span>
      <div class="notification__content__tag">
        <div class="notification__content__icon"><img src="${iconUrl}" alt="" /></div>
        <span class="notification__content__tag-name">${this.escapeHtml(label)}</span>
      </div>`;
        } else {
            middle = `${avatarTag}<span class="notification__content__status">${message}</span>`;
        }

        return `<li class="home-page__notifications__item ${mod}" data-notification-id="${id}" data-timeline-id="${tid}" role="listitem">
    <div class="notification__content">
      <div class="notification__content__type">
        ${middle}
      </div>
      ${messageBlock}
    </div>
    <button type="button" class="notification__view" data-action="notif-open-timeline"><span>${this._data.home_page.view_label}</span></button>
  </li>`;
    }

    listNotificationEmpty(isUnread, message = null) {
        const msg =
            message != null
                ? message
                : isUnread
                  ? this._data.home_page.new_notification_empty
                  : this._data.home_page.old_notification_empty;
        return `<li class="home-page__notifications__list-empty" role="status"><p class="home-page__notifications__list-empty-message">${this.escapeHtml(msg)}</p></li>`;
    }

    async loadNotificationsList() {
        const $app = $(this.elms.app);
        const $u = $app.find(this.elms.notifListUnread).first();
        const $r = $app.find(this.elms.notifListRead).first();
        if (!$u.length) return;
        const teamId = this._teamId;
        if (!teamId) return;
        const [res, err] = await bdjs.goAsync(
            bdapi.post("game/get-notifications", {
                team_id: teamId,
                limit_unread: 50,
                limit_read: 100,
            }),
        );
        if (err) {
            $u.html(
                this.listNotificationEmpty(
                    true,
                    this._data.home_page.new_notification_empty,
                ),
            );
            return;
        }
        const payload = res?.data?.data;
        if (!payload) {
            $u.html(
                this.listNotificationEmpty(
                    true,
                    this._data.home_page.new_notification_empty,
                ),
            );
            if ($r.length) {
                $r.html(
                    this.listNotificationEmpty(
                        false,
                        this._data.home_page.old_notification_empty,
                    ),
                );
            }
            return;
        }
        const unread = Array.isArray(payload.unread) ? payload.unread : [];
        const read = Array.isArray(payload.read) ? payload.read : [];
        if (typeof payload.unread_count === "number") {
            this.updateNotificationBadgeCount(payload.unread_count);
        }
        const bothEmpty = unread.length === 0 && read.length === 0;
        $u.html(
            unread.length
                ? unread.map((n) => this.buildNotificationItemHtml(n)).join("")
                : this.listNotificationEmpty(
                      true,
                      bothEmpty
                          ? this._data.home_page.new_notification_empty
                          : this._data.home_page.new_notification_empty,
                  ),
        );
        if ($r.length) {
            $r.html(
                read.length
                    ? read
                          .map((n) => this.buildNotificationItemHtml(n))
                          .join("")
                    : this.listNotificationEmpty(
                          false,
                          bothEmpty
                              ? this._data.home_page.old_notification_empty
                              : this._data.home_page.old_notification_empty,
                      ),
            );
        }
    }

    openNotificationsOverlay() {
        const $o = $(this.elms.app).find(this.elms.notificationsOverlay);
        if (!$o.length) return;
        $o.addClass(this.classes.notifOverlayOpen);
        $o.attr("aria-hidden", "false");
        $(this.elms.app)
            .find(this.elms.notifOpenButton)
            .attr("aria-expanded", "true");
        setTimeout(() => this.attachNotificationBackdropClose(), 0);
    }

    handleNotificationsOpenClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const $o = $(this.elms.app).find(this.elms.notificationsOverlay);
        if ($o.length && $o.hasClass(this.classes.notifOverlayOpen)) {
            this.closeNotificationsOverlay();
            return;
        }
        $(this.elms.managerDropdown).removeClass(this.classes.isOpen);
        this.openNotificationsOverlay();
        this.loadNotificationsList();
    }

    handleNotificationsCloseClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.closeNotificationsOverlay();
    }

    async handleNotificationsMarkAllClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this._teamId) {
            return;
        }
        const [res] = await bdjs.goAsync(
            bdapi.post("game/mark-all-notifications-read", {
                team_id: this._teamId,
            }),
        );
        const d = res?.data?.data;
        if (d && typeof d.unread_count === "number") {
            this.updateNotificationBadgeCount(d.unread_count);
        } else {
            this.updateNotificationBadgeCount(0);
        }
        await this.loadNotificationsList();
    }

    async openTimelineById(timelineId) {
        const id = Number(timelineId) || 0;
        if (!id) {
            return;
        }
        this.closeNotificationsOverlay();
        this.pauseAllVideos();
        const teamId = this._teamId || localStorage.getItem("teamId");
        const [res] = await bdjs.goAsync(
            bdapi.post("game/get-timeline-data", {
                team_id: teamId,
                timeline_id: id,
            }),
        );
        const item = res?.data?.data?.[0] ?? null;
        if (item) {
            this.populateChatDrawer(item);
        }
        $(this.elms.chatDrawer).addClass(this.classes.isOpen);
        this.updateChatSubmitState();
        this.attachChatDrawerOutsideClose();
    }

    async handleNotificationItemOpen(e) {
        e.preventDefault();
        const $li = $(e.currentTarget);
        if ($li.hasClass("home-page__notifications__list-empty")) {
            return;
        }
        const notificationId = Number($li.data("notificationId")) || 0;
        const timelineId = Number($li.data("timelineId")) || 0;
        if (notificationId && this._teamId) {
            const [res] = await bdjs.goAsync(
                bdapi.post("game/mark-notification-read", {
                    team_id: this._teamId,
                    notification_id: notificationId,
                }),
            );
            const d = res?.data?.data;
            if (d && typeof d.unread_count === "number") {
                this.updateNotificationBadgeCount(d.unread_count);
            }
        }
        if (timelineId) {
            await this.openTimelineById(timelineId);
        } else {
            this.closeNotificationsOverlay();
        }
        await this.loadNotificationsList();
    }

    checkUnfinishedAbandonedChallenge() {
        const unfinishedAbandonedChallenge = this._unfinishedAbandonedChallenge;
        if (unfinishedAbandonedChallenge) {
            $(this.elms.abandonNotificationPopupModal).addClass(
                this.classes.modalOpen,
            );
        }
    }

    handleAbandonNotificationPopupCancelClick(e) {
        e.preventDefault();
        $(this.elms.abandonNotificationPopupModal).removeClass(
            this.classes.modalOpen,
        );
    }

    async handleAbandonNotificationPopupConfirmClick(e) {
        e.preventDefault();
        GameLogic.goToPage("challenge-page");
    }

    clearChallengedActivityTimers() {
        this.clearQuizCountdown();
        this.clearRaceCountUp();
    }

    /**
     * Active step body inside `.modal__sections` (the segment container for quiz/race/question UI).
     *
     * @returns {BD_JQuery}
     */
    getActiveModalBody() {
        return $(this.elms.modalSections).find(
            this.elms.modalSectionActiveBody,
        );
    }

    /**
     * One multiple-choice segment by `data-question-index` (quiz grading / race MC).
     *
     * @param {BD_JQuery} $body
     * @param {number} index
     * @returns {BD_JQuery}
     */
    findMultipleChoiceSegment($body, index) {
        const elms = this.elms;
        return $body.find(
            `${elms.segmentMultipleChoice}[${elms.attrQuestionIndex}="${index}"]`,
        );
    }

    /**
     * Appends MC `<li>` options; `data-id` must stay parseable by {@link parseQuizOptionAnswerIndex}.
     *
     * @param {BD_JQuery} $options
     * @param {object} opts
     * @param {string} opts.optionIdPrefix e.g. `quiz_option` or `race_option`
     * @param {number} opts.questionIndex
     * @param {unknown} opts.answers
     */
    appendMcOptionList($options, { optionIdPrefix, questionIndex, answers }) {
        const c = this.classes;
        if (!Array.isArray(answers)) {
            return;
        }
        answers.forEach((answer, i) => {
            const optionId = `${optionIdPrefix}_${questionIndex}_${i}`;
            const $opt = $(`
                        <li class="${c.segmentOption}" data-id="${optionId}">
                            <div class="${c.segmentOptionContent}">
                                <div class="${c.segmentOptionBullet}">
                                    <span>${String.fromCharCode(65 + i)}</span>
                                </div>
                                <span class="${c.segmentOptionText}">${String(answer.answer || "")}</span>
                            </div>
                        </li>
                    `);
            $options.append($opt);
        });
    }
    challengedExtrasTypeClass(type) {
        const c = this.classes;
        switch (type) {
            case "race":
                return c.extraTypeRace;
            case "quiz":
                return c.extraTypeQuiz;
            case "question":
                return c.extraTypeQuestions;
            default:
                return c.extraTypeQuestions;
        }
    }

    /**
     * @param {string | undefined} type
     */
    challengedFormatTypeLabel(type) {
        return String(type ?? "").toUpperCase();
    }

    startChallengedActivityModalBody() {
        if (!this._challengedActivityExtra) {
            return;
        }

        const elms = this.elms;
        const c = this.classes;

        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionActive);

        $(elms.modalStep).each((i, stepEl) => {
            const $step = $(stepEl);
            $step.removeClass(c.stepAll);
            if (i === 0) {
                $step.addClass(c.isActive);
            } else {
                $step.addClass(c.isUnstarted);
            }
        });

        $(elms.playerGridItem).removeClass(c.playerAll);
        $(elms.fullscreenContinueButton)
            .removeClass(c.isAnswering)
            .prop("disabled", true);

        const $body = this.getActiveModalBody();
        $body
            .find(elms.modalSectionSegment)
            .not(elms.isTemplateSelector)
            .remove();

        const type = this._challengedActivityExtra.type;
        switch (type) {
            case "question":
                this._questions = this._challengedActivityExtra.question;
                {
                    const $tpl = $body
                        .find(elms.segmentTextInputTemplate)
                        .first();
                    if ($tpl.length) {
                        const $textSeg = $tpl
                            .clone(true, true)
                            .removeClass(c.isTemplate);
                        $textSeg
                            .find(elms.segmentTitle)
                            .text(String(this._questions ?? ""));
                        $textSeg.find(elms.segmentTextareaField).val("");
                        $textSeg.addClass(c.isActive);
                        $body.append($textSeg);
                    }
                }
                break;
            case "quiz": {
                this._quizIndex = 0;
                this._userAnswers = {};
                this._questions = this._challengedActivityExtra.quiz_questions;
                this.populateQuizProgress(
                    String(this._challengedActivityExtra.timer ?? ""),
                );
                const qLen = Array.isArray(this._questions)
                    ? this._questions.length
                    : 0;
                $(this.elms.quizSegments).html(
                    `<span><b>${this._quizIndex + 1}</b>/${qLen}</span>`,
                );
                this.populateQuizQuestion(this._questions);
                $(this.elms.fullscreenContinueButton)
                    .addClass(this.classes.isAnswering)
                    .prop("disabled", true);
                break;
            }
            case "race": {
                this._raceIndex = 0;
                this._userAnswers = {};
                this._questions = this._challengedActivityExtra.race_questions;
                this.populateRaceQuestions(
                    Array.isArray(this._questions) ? this._questions : [],
                );
                this.clearRaceCountUp();
                this.startRaceCountUp();
                $(this.elms.fullscreenContinueButton)
                    .addClass(this.classes.isAnswering)
                    .prop("disabled", true);
                this.syncRaceBevestigenEnabled();
                break;
            }
            default:
                this._questions = {};
                break;
        }

        $(this.elms.activityFullModal)
            .removeClass(this.classes.extraTypeAll)
            .addClass(
                this.challengedExtrasTypeClass(/** @type {string} */ (type)),
            );
        $(this.elms.fullscreenInfoTagLabel).text(
            this.challengedFormatTypeLabel(/** @type {string} */ (type)),
        );
        $(this.elms.fullscreenImage).attr(
            "src",
            String(this._challengedActivityExtra.image ?? ""),
        );
        $(this.elms.fullscreenTitle).text(
            String(this._challengedActivityExtra.title ?? ""),
        );

        $(this.elms.activityFullModal)
            .addClass(this.classes.modalOpen)
            .addClass(this.classes.activityChallengedResponder);
    }

    closeChallengedActivityFullModal(e) {
        e.preventDefault();
        this.clearChallengedActivityTimers();
        this.resetChallengedActivityFlowState();
        this._quizIndex = 0;
        this._raceIndex = 0;
        this._userAnswers = {};
        $(this.elms.fullscreenContinueButton).removeClass(
            this.classes.isAnswering,
        );
        const c = this.classes;
        $(this.elms.activityFullModal)
            .removeClass(c.modalOpen)
            .removeClass(c.activityChallengedResponder);
        this._challengedActivityExtra = null;
        this._challengedActivityTimelineId = 0;
    }
    resetChallengedActivityFlowState() {
        const elms = this.elms;
        const c = this.classes;

        $(elms.activityFullModal)
            .removeClass(c.modalOpen)
            .removeClass(c.extraTypeAll)
            .removeClass(c.activityChallengedResponder);

        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionActive);

        $(elms.modalStep).each((i, stepEl) => {
            const $step = $(stepEl);
            $step.removeClass(c.stepAll);
            if (i === 0) {
                $step.addClass(c.isActive);
            } else {
                $step.addClass(c.isUnstarted);
            }
        });

        this.getActiveModalBody()
            .find(elms.modalSectionSegment)
            .not(elms.isTemplateSelector)
            .remove();
        this._quizMcTemplate = null;
        this._raceMcTemplate = null;
        this._raceTextTemplate = null;
        $(elms.playerGridItem).removeClass(c.playerAll);
        $(elms.fullscreenContinueButton)
            .removeClass(c.isAnswering)
            .prop("disabled", true);

        this.clearChallengedActivityTimers();
        this._quizIndex = 0;
        this._raceIndex = 0;
        this._userAnswers = {};
    }
    handleChallengedActivityStepsContinue(e) {
        e.preventDefault();
        if (!this._challengedActivityExtra) {
            return;
        }
        const type = this._challengedActivityExtra.type;
        const c = this.classes;
        const $modalSections = $(this.elms.modalSections);

        if (
            (type === "quiz" || type === "race") &&
            $modalSections.hasClass(c.isSectionFinished)
        ) {
            this.submitChallengedExtrasResponse();
            return;
        }

        this.handleChallengedActivityContinueMainFlow(
            /** @type {string | undefined} */ (type),
        );
    }
    handleChallengedActivityContinueMainFlow(type) {
        switch (type) {
            case "quiz":
                this.handleChallengedStoreQuizStepsContinue();
                break;
            case "race":
                this.handleChallengedRaceStepsContinue();
                break;
            default:
                break;
        }
    }
    handleChallengedSegmentTextareaInput(e) {
        e.preventDefault();
        const type = this._challengedActivityExtra?.type;
        if (type === "race") {
            this.syncRaceBevestigenEnabled();
        }
    }

    handleChallengedQuizSegmentOptionClick(e) {
        e.preventDefault();
        const activityType = this._challengedActivityExtra?.type;
        if (activityType !== "quiz" && activityType !== "race") {
            return;
        }
        const c = this.classes;
        const elms = this.elms;
        const $opt = $(e.currentTarget);
        const $segment = $opt.closest(elms.segmentMultipleChoice);
        if (!$segment.length) {
            return;
        }
        const segIdx = parseInt(
            $segment.attr(elms.attrQuestionIndex) ?? "",
            10,
        );
        const expectedIdx =
            activityType === "quiz" ? this._quizIndex : this._raceIndex;
        if (!Number.isFinite(segIdx) || segIdx !== expectedIdx) {
            return;
        }
        if ($segment.hasClass(c.isAnswered)) {
            return;
        }

        $opt.siblings(elms.segmentOption).removeClass(c.isSelected);
        $opt.addClass(c.isSelected);

        const $btn = $(elms.fullscreenContinueButton);
        if ($btn.hasClass(c.isAnswering)) {
            $btn.prop("disabled", false);
        }
        if (activityType === "race") {
            this.syncRaceBevestigenEnabled();
        }
    }
    getQuizCorrectAnswerIndex(answers) {
        if (!Array.isArray(answers)) {
            return -1;
        }
        return answers.findIndex(
            (a) =>
                a &&
                (a.is_correct === true ||
                    a.is_correct === 1 ||
                    a.is_correct === "1"),
        );
    }

    /**
     * @param {string | undefined} dataId e.g. `quiz_option_0_2`
     * @returns {number}
     */
    parseQuizOptionAnswerIndex(dataId) {
        const m = String(dataId ?? "").match(/_(\d+)$/);
        return m ? parseInt(m[1], 10) : -1;
    }

    handleChallengedStoreQuizStepsContinue() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }

        if ($btn.hasClass(c.isAnswering)) {
            this.gradeCurrentQuizQuestion();
            return;
        }

        if (this._quizIndex < questions.length - 1) {
            this._quizIndex += 1;
            const $body = this.getActiveModalBody();
            const $prev = this.findMultipleChoiceSegment(
                $body,
                this._quizIndex - 1,
            );
            const $next = this.findMultipleChoiceSegment(
                $body,
                this._quizIndex,
            );
            if (!$next.length) {
                return;
            }
            if ($prev.length) {
                $prev.removeClass(c.isActive);
            }
            $next.addClass(c.isActive);
            $(elms.quizSegments).html(
                `<span><b>${this._quizIndex + 1}</b>/${questions.length}</span>`,
            );
            $btn.addClass(c.isAnswering).prop("disabled", true);
            return;
        }

        this.showQuizFinishedSection();
    }

    /**
     * Sums points and counts correct/incorrect from graded question entries in `_userAnswers`.
     */
    getQuizSessionStats() {
        const metaKey = this.elms.quizSummaryMetaKey;
        let totalPoints = 0;
        let correctCount = 0;
        let incorrectCount = 0;
        for (const [key, raw] of Object.entries(this._userAnswers)) {
            if (key === metaKey || !raw || typeof raw !== "object") {
                continue;
            }
            const entry = /** @type {{ correct?: boolean, score?: number }} */ (
                raw
            );
            totalPoints += Math.max(0, Number(entry.score) || 0);
            if (entry.correct === true) {
                correctCount += 1;
            } else if (entry.correct === false) {
                incorrectCount += 1;
            }
        }
        return { totalPoints, correctCount, incorrectCount };
    }

    showQuizFinishedSection() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const totalSec = this._quizTimerTotalSec;
        const remaining = this._quizTimerRemainingSec;
        const completionTimeSec =
            totalSec > 0 ? Math.max(0, totalSec - remaining) : 0;

        this.stopQuizCountdownIntervalOnly();

        const { totalPoints, correctCount, incorrectCount } =
            this.getQuizSessionStats();

        const $finished = $(elms.activityFullSectionFinished);
        $finished.find(elms.quizResultsPointsValue).text(String(totalPoints));
        $finished
            .find(elms.quizResultsTimeValue)
            .text(
                totalSec > 0
                    ? this.formatDurationHuman(completionTimeSec)
                    : "0m 0s",
            );
        $finished
            .find(elms.quizResultsAnswersCorrectText)
            .text(`${correctCount} correct`);
        $finished
            .find(elms.quizResultsAnswersIncorrectText)
            .text(`${incorrectCount} incorrect`);
        const spEc = /** @type {{ subtitle_quiz?: string }} */ (
            this.getStorePageConfig()?.extra_completion ?? {}
        );
        let finishedSubtitle = String(spEc.subtitle_quiz ?? "");
        finishedSubtitle = finishedSubtitle.replace(
            "{extra_type}",
            String(this._challengedActivityExtra?.type ?? ""),
        );
        $finished
            .find(elms.finishedSectionTitle)
            .first()
            .text(finishedSubtitle);

        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionFinished);
        $btn.removeClass(c.isAnswering).prop("disabled", false);

        this._userAnswers[elms.quizSummaryMetaKey] = {
            completionTimeSec,
            totalPoints,
            correctCount,
            incorrectCount,
        };
    }

    gradeCurrentQuizQuestion() {
        const elms = this.elms;
        const c = this.classes;
        const idx = this._quizIndex;
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return;
        }
        const question = questions[idx];
        if (!question) {
            return;
        }

        const $body = this.getActiveModalBody();
        const $segment = this.findMultipleChoiceSegment($body, idx);
        if (!$segment.length) {
            return;
        }
        const $selected = $segment.find(elms.segmentOptionSelected);
        if (!$selected.length) {
            return;
        }

        const answers = question.answers;
        const correctIndex = this.getQuizCorrectAnswerIndex(answers);
        const dataId = $selected.attr("data-id") || "";
        const selectedIndex = this.parseQuizOptionAnswerIndex(dataId);
        const correct =
            selectedIndex >= 0 &&
            correctIndex >= 0 &&
            selectedIndex === correctIndex;
        const scoreAwarded = correct
            ? Math.max(0, Number(question.score) || 0)
            : 0;

        this._userAnswers[idx] = {
            selectedIndex,
            correct,
            score: scoreAwarded,
        };

        $segment
            .find(elms.segmentOptions)
            .find(elms.segmentOption)
            .each((i, el) => {
                const $opt = $(el);
                $opt.addClass(i === correctIndex ? c.isCorrect : c.isIncorrect);
            });

        $segment.addClass(c.isAnswered);
        $(elms.fullscreenContinueButton).removeClass(c.isAnswering);
    }

    /**
     * Saves unanswered quiz entries as incorrect when timer expires.
     * If an option was selected but not confirmed, it is still stored as incorrect.
     */
    markRemainingQuizQuestionsIncorrect() {
        const elms = this.elms;
        const c = this.classes;
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }

        const $body = this.getActiveModalBody();
        questions.forEach((question, idx) => {
            if (this._userAnswers[idx]) {
                return;
            }

            const $segment = this.findMultipleChoiceSegment($body, idx);
            if (!$segment.length) {
                return;
            }
            const $selected = $segment.find(elms.segmentOptionSelected);
            const selectedIndex = $selected.length
                ? this.parseQuizOptionAnswerIndex(
                      $selected.attr("data-id") || "",
                  )
                : -1;
            const correctIndex = this.getQuizCorrectAnswerIndex(
                question?.answers,
            );

            this._userAnswers[idx] = {
                selectedIndex,
                correct: false,
                score: 0,
            };

            $segment
                .find(elms.segmentOptions)
                .find(elms.segmentOption)
                .each((i, optEl) => {
                    const $opt = $(optEl);
                    $opt.addClass(
                        i === correctIndex ? c.isCorrect : c.isIncorrect,
                    );
                });
            $segment.addClass(c.isAnswered);
        });
    }

    /**
     * Ends quiz immediately on timeout and marks all remaining questions incorrect.
     */
    finalizeQuizOnTimeout() {
        if (this._challengedActivityExtra?.type !== "quiz") {
            return;
        }
        if (
            $(this.elms.modalSections).hasClass(this.classes.isSectionFinished)
        ) {
            return;
        }
        this.markRemainingQuizQuestionsIncorrect();
        $(this.elms.fullscreenContinueButton).removeClass(
            this.classes.isAnswering,
        );
        this.showQuizFinishedSection();
    }

    /**
     * Clears the quiz timer interval without resetting elapsed/total (e.g. after quiz completion).
     */
    stopQuizCountdownIntervalOnly() {
        if (this._quizTimerIntervalId != null) {
            clearInterval(this._quizTimerIntervalId);
            this._quizTimerIntervalId = null;
        }
    }

    /**
     * Stop the quiz countdown interval and reset timer state (modal closed or flow reset).
     */
    clearQuizCountdown() {
        this.stopQuizCountdownIntervalOnly();
        this._quizTimerTotalSec = 0;
        this._quizTimerRemainingSec = 0;
        $(this.elms.modalProgressTrack).removeClass(
            this.classes.quizTimerLabelOutside,
        );
    }

    /**
     * @param {string | number} timerMinutesStr Total duration in minutes (API string).
     */
    parseTimerMinutesToSeconds(timerMinutesStr) {
        const n = parseFloat(String(timerMinutesStr ?? "").replace(",", "."));
        if (!Number.isFinite(n) || n < 0) return 0;
        return Math.round(n * 60);
    }

    /**
     * @param {number} totalSeconds
     */
    formatSecondsToMmSs(totalSeconds) {
        const s = Math.max(0, Math.floor(totalSeconds));
        const mm = Math.floor(s / 60);
        const ss = s % 60;
        return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
    }

    /**
     * Human-readable duration for quiz results (e.g. `1m 48s`).
     * @param {number} totalSeconds
     * @returns {string}
     */
    formatDurationHuman(totalSeconds) {
        const s = Math.max(0, Math.floor(totalSeconds));
        const mm = Math.floor(s / 60);
        const ss = s % 60;
        if (mm === 0) {
            return `${ss}s`;
        }
        return `${mm}m ${ss}s`;
    }

    updateQuizProgressUI() {
        const elms = this.elms;
        const c = this.classes;
        const total = this._quizTimerTotalSec;
        const remaining = this._quizTimerRemainingSec;
        const pct = total > 0 ? (remaining / total) * 100 : 0;
        $(elms.modalProgressFill).attr("style", `width: ${pct}%;`);
        $(elms.modalProgressFillSpan).text(this.formatSecondsToMmSs(remaining));
        $(elms.modalProgressTrack).toggleClass(
            c.quizTimerLabelOutside,
            pct >= 0 && pct <= 50,
        );
    }

    /**
     * Shows remaining time as mm:ss and a fill width from 100% (full time) to 0%.
     * @param {string | number} timerMinutesStr Total duration in minutes (string from extra).
     */
    populateQuizProgress(timerMinutesStr) {
        this.clearQuizCountdown();
        const totalSec = this.parseTimerMinutesToSeconds(timerMinutesStr);
        this._quizTimerTotalSec = totalSec;
        this._quizTimerRemainingSec = totalSec;
        this.updateQuizProgressUI();
        if (totalSec <= 0) {
            this.finalizeQuizOnTimeout();
            return;
        }
        this._quizTimerIntervalId = setInterval(() => {
            this._quizTimerRemainingSec = Math.max(
                0,
                this._quizTimerRemainingSec - 1,
            );
            this.updateQuizProgressUI();
            if (this._quizTimerRemainingSec <= 0) {
                if (this._quizTimerIntervalId != null) {
                    clearInterval(this._quizTimerIntervalId);
                    this._quizTimerIntervalId = null;
                }
                this.finalizeQuizOnTimeout();
            }
        }, 1000);
    }

    populateQuizQuestion(questions) {
        const elms = this.elms;
        const c = this.classes;
        const $body = this.getActiveModalBody();

        if (!this._quizMcTemplate || !this._quizMcTemplate.length) {
            const $src = $body.find(elms.segmentMultipleChoiceTemplate).first();
            if (!$src.length) return;
            this._quizMcTemplate = $src
                .clone(true, true)
                .removeClass(c.isTemplate);
        }
        $body
            .find(elms.segmentMultipleChoice)
            .not(elms.isTemplateSelector)
            .remove();

        if (!Array.isArray(questions)) return;

        questions.forEach((question, idx) => {
            const $segment = this._quizMcTemplate.clone(true, true);
            $segment.attr(elms.attrQuestionIndex, String(idx));
            $segment
                .find(elms.segmentTitle)
                .text(String(question.question || ""));

            const $options = $segment.find(elms.segmentOptions);
            $options.empty();

            this.appendMcOptionList($options, {
                optionIdPrefix: "quiz_option",
                questionIndex: idx,
                answers: question.answers,
            });

            if (idx === 0) {
                $segment.addClass(c.isActive);
            }

            $body.append($segment);
        });
    }

    stopRaceCountUpIntervalOnly() {
        if (this._raceTimerIntervalId != null) {
            clearInterval(this._raceTimerIntervalId);
            this._raceTimerIntervalId = null;
        }
    }

    clearRaceCountUp() {
        this.stopRaceCountUpIntervalOnly();
        this._raceElapsedSec = 0;
        $(this.elms.raceTimerTime).text(this.formatSecondsToMmSs(0));
    }

    updateRaceTimerUI() {
        $(this.elms.raceTimerTime).text(
            this.formatSecondsToMmSs(this._raceElapsedSec),
        );
    }

    startRaceCountUp() {
        this.stopRaceCountUpIntervalOnly();
        this._raceElapsedSec = 0;
        this.updateRaceTimerUI();
        this._raceTimerIntervalId = setInterval(() => {
            this._raceElapsedSec += 1;
            this.updateRaceTimerUI();
        }, 1000);
    }

    /**
     * Enables/disables Bevestigen during race while `isAnswering` is active.
     */
    syncRaceBevestigenEnabled() {
        if (this._challengedActivityExtra?.type !== "race") {
            return;
        }
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        if (!$btn.hasClass(c.isAnswering)) {
            $btn.prop("disabled", false);
            return;
        }
        const q = questions[this._raceIndex];
        if (!q) {
            return;
        }
        const $body = this.getActiveModalBody();
        if (q.type === "essay") {
            const $ta = $body
                .find(".segment-text-input")
                .not(elms.isTemplateSelector)
                .filter(`.${c.isActive}`)
                .find(elms.segmentTextareaField);
            const ok = String($ta.val() ?? "").trim().length > 0;
            $btn.prop("disabled", !ok);
            return;
        }
        const $segment = this.findMultipleChoiceSegment($body, this._raceIndex);
        const hasSel = $segment.find(elms.segmentOptionSelected).length > 0;
        $btn.prop("disabled", !hasSel);
    }

    /**
     * @param {unknown[]} questions
     */
    populateRaceQuestions(questions) {
        const elms = this.elms;
        const c = this.classes;
        const $body = this.getActiveModalBody();

        if (!this._raceMcTemplate || !this._raceMcTemplate.length) {
            const $mc = $body.find(elms.segmentMultipleChoiceTemplate).first();
            if (!$mc.length) {
                return;
            }
            this._raceMcTemplate = $mc
                .clone(true, true)
                .removeClass(c.isTemplate);
        }
        if (!this._raceTextTemplate || !this._raceTextTemplate.length) {
            const $tx = $body.find(elms.segmentTextInputTemplate).first();
            if (!$tx.length) {
                return;
            }
            this._raceTextTemplate = $tx
                .clone(true, true)
                .removeClass(c.isTemplate);
        }

        $body
            .find(elms.segmentMultipleChoice)
            .not(elms.isTemplateSelector)
            .remove();
        $body.find(".segment-text-input").not(elms.isTemplateSelector).remove();

        if (!Array.isArray(questions)) {
            return;
        }

        questions.forEach((raw, idx) => {
            const question =
                /** @type {{ type?: string, question?: string, answers?: Array<{ answer?: string }>, essay_answers?: Array<{ answer?: string }> }} */ (
                    raw
                );
            const qType = String(question?.type ?? "multiple");
            if (qType === "essay") {
                const $segment = this._raceTextTemplate.clone(true, true);
                $segment.attr(elms.attrQuestionIndex, String(idx));
                $segment
                    .find(elms.segmentTitle)
                    .text(String(question.question || ""));
                $segment.find(elms.segmentTextareaField).val("");
                if (idx === 0) {
                    $segment.addClass(c.isActive);
                }
                $body.append($segment);
            } else {
                const $segment = this._raceMcTemplate.clone(true, true);
                $segment.attr(elms.attrQuestionIndex, String(idx));
                $segment
                    .find(elms.segmentTitle)
                    .text(String(question.question || ""));

                const $options = $segment.find(elms.segmentOptions);
                $options.empty();

                this.appendMcOptionList($options, {
                    optionIdPrefix: "race_option",
                    questionIndex: idx,
                    answers: question.answers,
                });

                if (idx === 0) {
                    $segment.addClass(c.isActive);
                }
                $body.append($segment);
            }
        });
    }

    handleChallengedRaceStepsContinue() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }

        if ($btn.hasClass(c.isAnswering)) {
            const q = questions[this._raceIndex];
            if (!q) {
                return;
            }
            if (String(q.type) === "essay") {
                if (this.commitCurrentRaceEssay()) {
                    this.advanceRaceUiAfterAnswerRecorded();
                }
                return;
            }
            if (this.recordRaceMcAnswer()) {
                this.advanceRaceUiAfterAnswerRecorded();
            }
            return;
        }
    }

    /**
     * Moves to the next race question or the finished screen (answer already stored in `_userAnswers`).
     */
    advanceRaceUiAfterAnswerRecorded() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return;
        }

        if (this._raceIndex < questions.length - 1) {
            this._raceIndex += 1;
            const $body = this.getActiveModalBody();
            $body
                .find(elms.modalSectionSegment)
                .not(elms.isTemplateSelector)
                .removeClass(c.isActive);
            $body
                .find(`[${elms.attrQuestionIndex}="${this._raceIndex}"]`)
                .addClass(c.isActive);
            $btn.addClass(c.isAnswering).prop("disabled", true);
            this.syncRaceBevestigenEnabled();
        } else {
            this.showRaceFinishedSection();
        }
    }

    /**
     * Records race MC answer (no correct/incorrect UI). Used with {@link advanceRaceUiAfterAnswerRecorded}.
     *
     * @returns {boolean}
     */
    recordRaceMcAnswer() {
        const elms = this.elms;
        const idx = this._raceIndex;
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return false;
        }
        const question = questions[idx];
        if (!question) {
            return false;
        }

        const $body = this.getActiveModalBody();
        const $segment = this.findMultipleChoiceSegment($body, idx);
        const $selected = $segment.find(elms.segmentOptionSelected);
        if (!$selected.length) {
            return false;
        }

        const answers = question.answers;
        const correctIndex = this.getQuizCorrectAnswerIndex(answers);
        const dataId = $selected.attr("data-id") || "";
        const selectedIndex = this.parseQuizOptionAnswerIndex(dataId);
        const correct =
            selectedIndex >= 0 &&
            correctIndex >= 0 &&
            selectedIndex === correctIndex;

        this._userAnswers[idx] = {
            selectedIndex,
            correct,
        };

        return true;
    }

    /**
     * @returns {boolean}
     */
    commitCurrentRaceEssay() {
        const elms = this.elms;
        const idx = this._raceIndex;
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return false;
        }
        const $body = this.getActiveModalBody();
        const $segment = $body.find(
            `.segment-text-input[${elms.attrQuestionIndex}="${idx}"]`,
        );
        const text = String(
            $segment.find(elms.segmentTextareaField).val() ?? "",
        ).trim();
        if (!text.length) {
            return false;
        }
        const question = questions[idx];
        const essayRows = question?.essay_answers;
        const allowed = Array.isArray(essayRows)
            ? essayRows
                  .map((row) => String(row?.answer ?? "").trim())
                  .filter((s) => s.length > 0)
            : [];
        const correct = allowed.some((a) => a === text);
        this._userAnswers[idx] = { text, correct };
        return true;
    }

    showRaceFinishedSection() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        this.stopRaceCountUpIntervalOnly();

        const completionTimeSec = this._raceElapsedSec;
        const timeLabel = this.formatSecondsToMmSs(completionTimeSec);
        $(elms.raceResultsTime).text(timeLabel);
        $(elms.raceTimerTime).text(timeLabel);

        this._userAnswers[elms.raceSummaryMetaKey] = {
            completionTimeSec,
        };

        const $finished = $(elms.activityFullSectionFinished);
        const spEcRace = /** @type {{ subtitle_race?: string }} */ (
            this.getStorePageConfig()?.extra_completion ?? {}
        );
        let finishedSubtitle = String(spEcRace.subtitle_race ?? "");
        finishedSubtitle = finishedSubtitle.replace(
            "{extra_type}",
            String(this._challengedActivityExtra?.type ?? ""),
        );
        $finished
            .find(elms.finishedSectionTitle)
            .first()
            .text(finishedSubtitle);

        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionFinished);
        $btn.removeClass(c.isAnswering).prop("disabled", false);
    }

    async submitChallengedExtrasResponse() {
        const extra = this._challengedActivityExtra;
        const timelineId = this._challengedActivityTimelineId;
        const teamId = this._teamId || localStorage.getItem("teamId");
        if (!extra || !timelineId || !teamId) {
            return;
        }

        const type = String(extra.type ?? "");
        let answer = "";
        if (type === "quiz" || type === "race") {
            answer = JSON.stringify(this._userAnswers);
        } else {
            answer = String($(this.elms.segmentTextarea).val() ?? "").trim();
        }
        if (!answer) {
            return;
        }

        const profileId = this._data?.profile?.ID;
        const payload = {
            team_id: teamId,
            timeline_id: timelineId,
            answer,
        };
        if (profileId) {
            payload.user_id = profileId;
        }

        const $btn = $(this.elms.fullscreenContinueButton);
        $btn.prop("disabled", true);
        const [res] = await bdjs.goAsync(
            bdapi.post("game/submit-extras-question-response", payload),
        );
        $btn.prop("disabled", false);
        if (!res?.data?.success) {
            return;
        }
        this.closeChallengedActivityFullModal(
            /** @type {{ preventDefault: () => void }} */ ({
                preventDefault() {},
            }),
        );
        await this.render();
    }
    handleChallengedRespondButtonClick(e) {
        e.preventDefault();
        $(e.currentTarget)
            .closest(this.elms.challengeRespondBlock)
            .removeClass(this.classes.isPlayer)
            .addClass(this.classes.hasOpened);
    }

    async handleRespondSubmitButtonClick(e) {
        e.preventDefault();
        const $block = $(e.currentTarget).closest(
            this.elms.challengeRespondBlock,
        );
        const $timelineItem = $block.closest(this.elms.timelineItem);
        const timelineId = Number($timelineItem.data("timeline-id")) || 0;
        const teamId = this._teamId || localStorage.getItem("teamId");
        const $textarea = $block.find(this.elms.respondTextarea);
        const $submit = $block.find(this.elms.respondSubmitButton);
        const answer = String($textarea.val() || "").trim();
        if (!timelineId || !teamId || !answer) {
            return;
        }

        const profileId = this._data?.profile?.ID;
        const payload = {
            team_id: teamId,
            timeline_id: timelineId,
            answer,
        };
        if (profileId) {
            payload.user_id = profileId;
        }

        $submit.prop("disabled", true);
        const [res] = await bdjs.goAsync(
            bdapi.post("game/submit-extras-question-response", payload),
        );
        $submit.prop("disabled", false);

        if (!res?.data?.success) {
            return;
        }

        await this.render();
    }

    async handleChallengedRightRespondButtonClick(e) {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        const $timelineItem = $btn.closest(this.elms.timelineItem);
        let timelineId = Number($timelineItem.data("timeline-id")) || 0;
        if (!timelineId) {
            const $drawer = $btn.closest(this.elms.chatDrawer);
            timelineId = Number($drawer.data("timeline-id")) || 0;
        }
        const teamId = this._teamId || localStorage.getItem("teamId");
        if (!timelineId || !teamId) {
            return;
        }
        const [res] = await bdjs.goAsync(
            bdapi.post("game/get-timeline-data", {
                team_id: teamId,
                timeline_id: timelineId,
            }),
        );
        const item = res?.data?.data?.[0] ?? null;
        const extraData = item?.extra_data;
        const type = String(extraData?.type ?? "");
        if (type !== "quiz" && type !== "race") {
            return;
        }
        this._challengedActivityTimelineId = timelineId;
        this._challengedActivityExtra = extraData;
        this.startChallengedActivityModalBody();
    }
}
